import React, { useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import { formatCurrency } from "@heartinz/finance";
import InvoiceActionFooter from "../a4Invoices/common/InvoiceActionFooter";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import PaySettleModal from "./common/PaySettleModal ";
import { useInvoiceData } from "./common/useInvoiceData";
import {
  capitalizeFirstLetter,
  joinAddress,
  loadImageDimensions,
  urlToBase64,
  wrapText,
} from "./common/invoiceUtils";
import { useShowAlert } from "../../../context/AlertContext";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../AxiosInstance";
import handleError from "../../../constants/handleError";
import ReturnSaleInvoice from "./ReturnSaleInvoice";
const StructuredInvoice = ({
  isData,
  selectedOption,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  isActive,
  optData,
  setOptData,
}) => {
  const invoiceData = useInvoiceData({
    isData,
    onClose,
    onDataUpdate,
    onDataChange,
    optData,
    setOptData,
  });
  const {
    data,
    globalData,
    selectedTheme,
    selectedSize,
    qrCodeDataUrl,
    setSelectedSize,
    terms,
    latestVersion,
    formatTrackMode,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,
    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,
    saleLoading,
    closeAuto,
    setCloseAuto,
    showConfirm,
    setShowConfirm,
    handleResetSale,
    saleTime,
    storeSettings,
    handleSelectedSale,
    handlelatestSale,
    isBillReceipt,
    documentTitle,
    handleGenerateInvoice,
    handleModeConfirm,
  } = invoiceData;
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    onClose();
  };
  const handleSelectedReturnSale = async (sale) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };
  const invLabel = isBillReceipt ? "Bill #:" : "Invoice #:";

  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const ensureSpace = (
      doc,
      currentY,
      requiredHeight,
      topMargin = 10,
      bottomMargin = 10,
    ) => {
      const pageH = doc.internal.pageSize.getHeight();
      if (currentY + requiredHeight > pageH - bottomMargin) {
        doc.addPage();
        return topMargin;
      }
      return currentY;
    };

    const drawLabelValue = (
      doc,
      label,
      value,
      x,
      y,
      maxWidth,
      lh,
      labelBold = true, // 👈 default bold
    ) => {
      if (!value) return y;

      const labelText = `${label}: `;

      doc.setFont(
        labelBold ? "Inter-Bold" : "Inter-Regular",
        labelBold ? "bold" : "normal",
      );

      const labelWidth = doc.getTextWidth(labelText);
      doc.text(labelText, x, y);

      doc.setFont("Inter-Regular", "normal");
      const wrapped = doc.splitTextToSize(value, maxWidth - labelWidth);
      doc.text(wrapped, x + labelWidth, y);

      return y + wrapped.length * lh;
    };

    /* -------------------------------------------------
     HEADER (AUTO HEIGHT)
  ------------------------------------------------- */
    const borderColor = "#C0C0C0";
    const headerY = 8;

    const leftBoxX = 8;
    const leftBoxW = 110; // ⬅️ reduced width
    const rightBoxX = leftBoxX + leftBoxW + 2;
    const rightBoxW = pageW - rightBoxX - 8;

    const titleHeight = 8;
    const lh = 3.8;

    const headerPaddingTop = 2;
    const headerPaddingBottom = 1;

    const contentX = leftBoxX + 32;
    const maxTextWidth = leftBoxW - 34;

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );

    let tempHeight = headerPaddingTop + titleHeight;

    // company name font size effect
    if (address) {
      tempHeight += doc.splitTextToSize(address, maxTextWidth).length * lh;
    }

    [
      globalData?.salefrom?.phone,
      globalData?.salefrom?.email,
      globalData?.salefrom?.gstnumber,
      globalData?.salefrom?.fssai,
      globalData?.salefrom?.cin,
      globalData?.salefrom?.pannumber,
    ].forEach((v) => {
      if (v) tempHeight += lh;
    });

    tempHeight += headerPaddingBottom;
    const logoBlockHeight = globalData?.salefrom?.image
      ? headerPaddingTop + 18 + headerPaddingBottom
      : 0;

    // ---- Calculate RIGHT SIDE minimum height ---- //
    const metaRowHeight = 6; // each row height
    const metaTopSpacing = 5; // space from top before first row
    const metaRows = 5; // Invoice#, Date, POS, Due Date, Sales Person
    const rightMinHeight = metaTopSpacing + metaRows * metaRowHeight + 1;

    // ---- Final Header Height ---- //
    const headerH = Math.max(tempHeight, logoBlockHeight, rightMinHeight) - 1;

    // LEFT HEADER BOX
    const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];
      const h = hex.replace("#", "");
      return [
        parseInt(h.substring(0, 2), 16),
        parseInt(h.substring(2, 4), 16),
        parseInt(h.substring(4, 6), 16),
      ];
    };

    const [r, g, b] = hexToRgb(borderColor);

    // Apply border color
    doc.setDrawColor(r, g, b);
    doc.setLineWidth(0.3);
    doc.rect(leftBoxX, headerY, leftBoxW, headerH);

    // LOGO

    if (globalData?.salefrom?.image) {
      try {
        const imagePath =
          uRLs.IMAGE_URL + "profile/" + globalData.salefrom.image;

        // Convert to base64
        const base64 = await urlToBase64(imagePath);

        // Natural dimensions
        const { width, height } = await loadImageDimensions(base64);

        //  Max logo area inside header box
        const maxWidth = 26;
        const maxHeight = headerH - 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);
        imgW *= ratio;
        imgH *= ratio;

        // Detect format
        const ext = imagePath.split(".").pop().toLowerCase();
        const format =
          ext === "png"
            ? "PNG"
            : ext === "jpg" || ext === "jpeg"
              ? "JPEG"
              : "JPEG";

        // Draw image
        doc.addImage(base64, format, leftBoxX + 2, headerY + 5, imgW, imgH);
      } catch (err) {
        console.warn("Logo load failed:", err);
      }
    }

    // COMPANY NAME
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.text(
      globalData?.salefrom?.title || "",
      contentX,
      headerY + headerPaddingTop + 4,
    );

    // COMPANY DETAILS
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    let cty = headerY + headerPaddingTop + titleHeight;
    if (address) {
      doc.setFont("Inter-Regular", "normal");
      const addrLines = doc.splitTextToSize(address, maxTextWidth);
      doc.text(addrLines, contentX, cty);
      cty += addrLines.length * lh;
    }

    // CONTACT & TAX INFO
    cty = drawLabelValue(
      doc,
      "Phone",
      globalData?.salefrom?.phone,
      contentX,
      cty,
      maxTextWidth,
      lh,
      false, // 👈 normal
    );

    cty = drawLabelValue(
      doc,
      "Email",
      globalData?.salefrom?.email,
      contentX,
      cty,
      maxTextWidth,
      lh,
      false, // 👈 normal
    );

    cty = drawLabelValue(
      doc,
      "GST",
      globalData?.salefrom?.gstnumber,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "FSSAI",
      globalData?.salefrom?.fssai,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "CIN",
      globalData?.salefrom?.cin,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "PAN",
      globalData?.salefrom?.pannumber,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    // RIGHT HEADER BOX
    doc.rect(rightBoxX, headerY, rightBoxW, headerH);
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);

    // Decide title text
    const invoiceText =
      globalData?.status === "CANCELLED"
        ? "CANCELLED"
        : globalData?.salemode
          ? documentTitle // eg: TAX INVOICE
          : "";

    // Optional: make CANCELLED stand out
    if (globalData?.status === "CANCELLED") {
      doc.setTextColor(200, 0, 0); // red
    }

    doc.text(invoiceText, rightBoxX + rightBoxW - 2, headerY + 3, {
      align: "right",
    });

    // reset color for rest of document
    doc.setTextColor(0, 0, 0);

    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;

    const meta = [
      [invLabel, globalData?.saleno],
      ["Date", invDate],
      ["Place Of Supply", globalData?.salefrom?.state || "-"],
      ["Due Date", invDate],
      ["Sales Person", globalData?.salesperson || ""],
    ];

    let my = headerY + 5;
    meta.forEach(([k, v]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text(k, rightBoxX + 2, my);
      doc.text(":", rightBoxX + 30, my);

      doc.setFont("Inter-Regular", "normal");
      doc.text(String(v || "-"), rightBoxX + 34, my);
      my += 6;
    });

    /* -------------------------------------------------
     CUSTOMER & SHIPPING (AUTO HEIGHT)
  ------------------------------------------------- */
    const pagePadding = 8;
    const gapBetweenBoxes = 2;
    const innerPadding = 2;
    const titleGap = 4; // space below title

    // total available width
    const availableWidth = pageW - pagePadding * 2 - gapBetweenBoxes;
    const boxWidth = availableWidth / 2;

    //  separate variables (no conflict with header)
    const custBoxX = pagePadding;
    const custBoxW = boxWidth;

    const shipBoxX = custBoxX + custBoxW + gapBetweenBoxes;
    const shipBoxW = boxWidth;

    const boxY = headerY + headerH + 2;
    let tableStartY;

    const hasSaleTo =
      globalData?.saleto &&
      (globalData.saleto.name ||
        globalData.saleto.addressline1 ||
        globalData.saleto.addressline2 ||
        globalData.saleto.district ||
        globalData.saleto.state ||
        globalData.saleto.pincode ||
        globalData.saleto.gstnumber);

    if (hasSaleTo && optData.isCustomerDisplay) {
      const lineHeight = 3;

      const innerTextWidthLeft = custBoxW - 4;
      const innerTextWidthRight = shipBoxW - 4;
       const saleto = globalData?.saleto;
      const locationParts = [saleto?.district, saleto?.state].filter(Boolean).join(", ");
      const locationString = locationParts 
        ? `${locationParts}${saleto?.pincode ? ` - ${saleto.pincode}` : ""}`
        : (saleto?.pincode || "");
       const customerText = [
        saleto?.name,
        (saleto?.addressline1 || saleto?.addressline2)
          ? [saleto?.addressline1, saleto?.addressline2].filter(Boolean).join(", ")
            : "",
        locationString,
        saleto?.phone ? `Phone : ${saleto.phone}` : "",
        saleto?.email ? `Email : ${saleto.email}` : "",
        saleto?.referenceid ? `Reference No : ${saleto.referenceid}` : "",
        saleto?.gstnumber ? `GSTIN : ${saleto.gstnumber}` : "",
        saleto?.fssai ? `FSSAI : ${saleto.fssai}` : "",
        saleto?.pannumber ? `PAN : ${saleto.pannumber}` : "",
        saleto?.cinnumber ? `CIN : ${saleto.cinnumber}` : "",
      ].filter(Boolean);
      // ---------- CUSTOMER TEXT
      // const customerText = [
      //   globalData?.saleto?.name,
      //   joinAddress(
      //     globalData?.saleto?.addressline1,
      //     globalData?.saleto?.addressline2,
      //   ),
      //   `${globalData?.saleto?.district}, ${globalData?.saleto?.state} - ${globalData?.saleto?.pincode}`,
      //   globalData?.saleto?.phone ? `Phone : ${globalData.saleto.phone}` : "",
      //   globalData?.saleto?.email ? `Email : ${globalData.saleto.email}` : "",
      //   globalData?.saleto?.referenceid
      //     ? `Reference No : ${globalData.saleto.referenceid}`
      //     : "",
      //   globalData?.saleto?.gstnumber
      //     ? `GSTIN : ${globalData.saleto.gstnumber}`
      //     : "",
      //   globalData?.saleto?.fssai ? `FASSI : ${globalData.saleto.fssai}` : "",
      //   globalData?.saleto?.pannumber
      //     ? `PAN : ${globalData.saleto.pannumber}`
      //     : "",
      //   globalData?.saleto?.cinnumber
      //     ? `CIN : ${globalData.saleto.cinnumber}`
      //     : "",
      // ].filter(Boolean);

      let customerLines = [];
      customerText.forEach((t) => {
        customerLines.push(...wrapText(doc, t, innerTextWidthLeft));
      });

      // ---------- SHIPPING TEXT
      const shippingText = [
        globalData?.saleto?.shippingAddress?.name,
        joinAddress(
          globalData?.saleto?.shippingAddress?.addressline1,
          globalData?.saleto?.shippingAddress?.addressline2,
        ),
        `${globalData?.saleto?.shippingAddress?.district}, ${globalData?.saleto?.shippingAddress?.city}, ${globalData?.saleto?.shippingAddress?.state},${globalData?.saleto?.shippingAddress?.country} - ${globalData?.saleto?.shippingAddress?.pincode}`,
        globalData?.transport || "",
      ].filter(Boolean);

      let shippingLines = [];
      shippingText.forEach((t) => {
        shippingLines.push(...wrapText(doc, t, innerTextWidthRight));
      });

      // ---------- HEIGHT CALCULATION ----//
      const customerTextStartY = boxY + innerPadding + 1 + titleGap;
      const shippingTextStartY = boxY + innerPadding + 1 + titleGap;
      const customerTextHeight = customerLines.length * lineHeight;
      const shippingTextHeight = shippingLines.length * lineHeight;
      const custBoxH = customerTextStartY - boxY + customerTextHeight + 1;

      const shipBoxH = shippingTextStartY - boxY + shippingTextHeight + 1;
      const boxH = Math.max(custBoxH, shipBoxH);

      // ---------- CUSTOMER BOX

      doc.rect(custBoxX, boxY, custBoxW, boxH);

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text(
        "Customer Details",
        custBoxX + innerPadding,
        boxY + innerPadding + 3,
      );

      doc.setFont("Inter-Regular", "normal");
      let cy = boxY + innerPadding + 3 + titleGap;

      customerLines.forEach((line) => {
        doc.text(line, custBoxX + innerPadding, cy);
        cy += lineHeight;
      });

      // ---------- SHIPPING BOX

      if (
        globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2
      ) {
        doc.rect(shipBoxX, boxY, shipBoxW, boxH);
        doc.setFont("Inter-Bold", "bold");
        doc.text(
          "Shipping Address",
          shipBoxX + innerPadding,
          boxY + innerPadding + 3,
        );

        doc.setFont("Inter-Regular", "normal");
        let sy = boxY + innerPadding + 4 + titleGap;

        shippingLines.forEach((line) => {
          doc.text(line, shipBoxX + innerPadding, sy);
          sy += lineHeight;
        });
      }
      tableStartY = boxY + boxH + 2;
    } else {
      tableStartY = boxY;
    }

    /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
    autoTable(doc, {
      startY: tableStartY,
      theme: "grid",
      margin: { left: 8, right: 5 },
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: 1,
        valign: "middle",
        overflow: "linebreak",
        lineWidth: 0.2,
        textColor: "#000000",
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 7,
        halign: "center",
        valign: "middle",
        cellPadding: 0.8,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
      },
      head: [
        [
          "S.No",
          "Description",
          "HSN/SAC",
          "MRP",
          "Base Price",
          "Qty",
          "Taxable Value",
          "Tax",
          "Tax Amount",
          "Amount",
        ],
      ],
      body: globalData?.saleitems.map((it, i) => {
        const rate = it.lineTotalTaxAmount;
        const amount = it.lineGrandTotal;
        const mrp = it.mrp;
        const baseprice = it.baseprice;
        const landingCost = it?.lineTotalLandingCost;
        const taxableValue = it.lineTotalBasePrice;

        return [
          i + 1,
          [it.title, it.note ? `-(${it.note})` : ""].filter(Boolean),
          it.hsnsac || "",
          `₹${mrp}`,
          `₹${baseprice}`,
          `${it.quantity} ${(() => {
            const unitCode = it?.isSecondaryUnit
              ? it?.unitConfig?.secondaryUnitCode
              : it?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          `₹${taxableValue}`,
          `${it.taxpercentage || 0}%`,
          `₹${rate}`,
          `₹${amount}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 61, halign: "left" },
        2: { cellWidth: 16, halign: "center" },
        3: { cellWidth: 17, halign: "right" },
        4: { cellWidth: 17, halign: "right" },
        5: { cellWidth: 12, halign: "center" },
        6: { cellWidth: 17, halign: "center" },
        7: { cellWidth: 10, halign: "center" },
        8: { cellWidth: 17, halign: "right" },
        9: { cellWidth: 17, halign: "right" },
      },
    });

    /* -------------------------------------------------
     TOTALS
  ------------------------------------------------- */
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom.statecode !== globalData?.saleto.statecode;

    const igst = globalData?.igstamount;
    const sgst = globalData?.sgstamount;
    const cgst = globalData?.cgstamount;
    const linetotalbaseprice = globalData?.totalbaseprice;
    const grantotal = globalData?.grandtotal;

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (onlineAmt > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (upiAmt > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (balanceAmt > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }
    let startY = doc.lastAutoTable.finalY + 4;
    startY = ensureSpace(doc, startY, 50);
    let leftY = startY;
    let rightY = startY;

    const valueX = pageW - 8;
    const labelX = valueX - 25;
    rightY = ensureSpace(doc, rightY, 35);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    // Total Taxable
    doc.text("Total Amount Before Tax :", labelX, rightY, { align: "right" });
    doc.text(`₹${linetotalbaseprice}`, valueX, rightY, {
      align: "right",
    });
    rightY += 5;

    // GST
    if (isInterState) {
      doc.text("IGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${igst}`, valueX, rightY, { align: "right" });
      rightY += 5;
    } else {
      doc.text("SGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${sgst}`, valueX, rightY, { align: "right" });
      rightY += 5;

      doc.text("CGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${cgst}`, valueX, rightY, { align: "right" });
      rightY += 5;
    }

    // Grand Total
    doc.setFont("Inter-Bold", "bold");
    doc.text("Total Amount :", labelX, rightY, { align: "right" });
    doc.text(`₹${grantotal}`, valueX, rightY, {
      align: "right",
    });
    rightY += 8;

    rightY = ensureSpace(doc, rightY, 25);
    const signBlockY = rightY;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 40;
        const maxHeight = 10;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          pageW - 8 - imgW,
          signBlockY,
          imgW,
          imgH,
        );
      } catch {
        console.warn("Signature load failed");
      }
    }

    doc.setFont("Inter-Regular", "normal");
    doc.text("Issued By, Signature", pageW - 8, signBlockY + 14, {
      align: "right",
    });

    doc.setFont("Inter-Bold", "bold");
    doc.text(globalData?.salefrom?.title || "", pageW - 8, signBlockY + 18, {
      align: "right",
    });

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text("Total Items :", leftBoxX, leftY);
    doc.text(String(globalData?.totalItems), leftBoxX + 20, leftY);
    leftY += 4;

    leftY = ensureSpace(doc, leftY, 30);
    if (paymentRows.length > 0 && optData?.isPayment) {
      autoTable(doc, {
        startY: leftY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 8 },
        tableWidth: 50,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 1,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 30, halign: "left" },
          1: { cellWidth: 20, halign: "right" },
        },
        theme: "grid",
      });

      leftY = doc.lastAutoTable.finalY + 5;
    } else {
      leftY += 5;
    }
    // =======================================
    // Bank Details + QR Code
    // =======================================
    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      leftY = ensureSpace(doc, leftY, 35);
      const bankX = leftBoxX;
      const qrSize = 28;
      const gap = 8;
      let bankY = leftY + 5;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", bankX, leftY);

      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18;
      let maxWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(`${item.label} :`, bankX, bankY);

        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), bankX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxWidth = Math.max(maxWidth, completeLineWidth);

        bankY += 4.5;
      });
      doc.setTextColor(0, 0, 0);

      if (qrCodeDataUrl) {
        const qrX = bankX + maxWidth + gap;
        const qrY = leftY - 2;

        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      leftY = Math.max(bankY, leftY + qrSize);
    }

    if (optData?.isRemark && globalData?.remark) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(72, 72, 72);

      const innerPaddingX = 2;
      // Spans across the full printable width of the page

      const remarkWidth = (pageW - leftBoxX * 2) * 0.65; // 65% of printable width
      const maxTextWidth = remarkWidth - innerPaddingX * 2;
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(globalData.remark),
        maxTextWidth,
      );

      const textLineHeight = 3.5;
      const boxPaddingTop = 2.5;
      const boxPaddingBottom = 2.5;

      const remarkHeight =
        boxPaddingTop + remarkLines.length * textLineHeight + boxPaddingBottom;

      // Ensure there's room on the page for the full-width block
      leftY = ensureSpace(doc, leftY, remarkHeight + 6) + 1;
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0);
      doc.text("Remark", leftBoxX, leftY);

      const boxStartY = leftY + 2;

      // Draw the full-width tight rounded container box
      doc.setDrawColor(180);
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0);

      let remarkY = boxStartY + boxPaddingTop;

      remarkLines.forEach((line) => {
        doc.text(line, leftBoxX, remarkY);
        remarkY += textLineHeight;
      });

      // Push vertical tracker below the full-row remark box
      leftY = boxStartY + remarkHeight;
    }
    if (terms?.length > 0) {
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      const termLines = doc.splitTextToSize(terms, pageW / 2 - 12);

      const termsHeight = termLines.length * 3.5 + 6;

      leftY = ensureSpace(doc, leftY, termsHeight);

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Terms & Conditions", leftBoxX, leftY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.text(termLines, leftBoxX, leftY + 4);

      leftY += termsHeight;
    }

    // draw table ONLY if rows exist

    if (storeSettings?.negobillBranding) {
      const y = pageH - 5;
      const rightX = pageW - 5;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");
      const boldW = doc.getTextWidth(boldText);

      const totalW = normalW + boldW;

      // Start X so whole string is right-aligned
      const startX = rightX - totalW;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, y);

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + normalW, y);
    }
    setDownload(false);
    return doc;
  };

  const generateInvoiceExactMapped = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const marginLeft = 8;
    const marginRight = 8;
    const contentWidth = pageW - marginLeft - marginRight;

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    /* =====================================================
     1️⃣ TOP TITLE BAR
  ===================================================== */

    const topBarY = 8;
    const topBarH = 8;

    doc.setLineWidth(0.3);
    doc.rect(marginLeft, topBarY, contentWidth, topBarH);

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text(
      data?.salemode ? formatTrackMode(data.salemode) : "TAX INVOICE",
      pageW / 2,
      topBarY + 5.5,
      { align: "center" },
    );

    doc.setFontSize(8);
    doc.text(
      data?.status === "CANCELLED" ? "CANCELLED" : "ORIGINAL FOR RECIPIENT",
      pageW - marginRight - 2,
      topBarY + 5.5,
      { align: "right" },
    );

    let y = topBarY + topBarH;

    /* =====================================================
     2️⃣ HEADER (LEFT COMPANY / RIGHT META)
  ===================================================== */

    const leftW = 110;
    const rightW = contentWidth - leftW;
    const headerH = 38;
    const padding = 4;

    doc.rect(marginLeft, y, leftW, headerH);
    doc.rect(marginLeft + leftW, y, rightW, headerH);

    const leftX = marginLeft + padding;
    const rightX = marginLeft + leftW + padding;

    const invDate = DateConverter.ISOToDisplayFormat(data?.saledate).date;

    const address = joinAddress(
      data?.salefrom?.addressline1,
      data?.salefrom?.addressline2,
      data?.salefrom?.district,
      data?.salefrom?.state,
      data?.salefrom?.pincode,
    );

    // Company
    doc.setFont("Inter-Bold", "bold");
    doc.text(data?.salefrom?.title || "", leftX, y + 6);

    doc.setFont("Inter-Regular", "normal");
    doc.text(`GSTIN: ${data?.salefrom?.gstnumber || "-"}`, leftX, y + 11);

    if (address) {
      const addrLines = doc.splitTextToSize(address, leftW - 8);
      doc.text(addrLines, leftX, y + 16);
    }

    if (data?.salefrom?.phone) {
      doc.text(`Mobile: ${data.salefrom.phone}`, leftX, y + 30);
    }

    // Meta
    const meta = [
      ["Invoice #", data?.saleno],
      ["Invoice Date", invDate],
      ["Place of Supply", data?.salefrom?.state || "-"],
      ["Due Date", invDate],
    ];

    let my = y + 8;
    meta.forEach(([label, value]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.text(label, rightX, my);

      doc.setFont("Inter-Regular", "normal");
      doc.text(String(value || "-"), rightX + 35, my);
      my += 6;
    });

    y += headerH;

    /* =====================================================
     3️⃣ CUSTOMER & SHIPPING
  ===================================================== */

    const boxGap = 2;
    const boxWidth = (contentWidth - boxGap) / 2;
    const custX = marginLeft;
    const shipX = custX + boxWidth + boxGap;
    const boxY = y;
    const lineHeight = 3.5;

    const customerAddr = joinAddress(
      data?.saleto?.addressline1,
      data?.saleto?.addressline2,
      data?.saleto?.district,
      data?.saleto?.state,
      data?.saleto?.pincode,
    );

    const custLines = doc.splitTextToSize(
      `${data?.saleto?.name || ""}\n${customerAddr || ""}`,
      boxWidth - 6,
    );

    const shipLines = doc.splitTextToSize(customerAddr || "-", boxWidth - 6);

    const boxH = Math.max(custLines.length, shipLines.length) * lineHeight + 10;

    doc.rect(custX, boxY, boxWidth, boxH);
    doc.rect(shipX, boxY, boxWidth, boxH);

    doc.setFont("Inter-Bold", "bold");
    doc.text("Customer Details", custX + 3, boxY + 5);
    doc.text("Shipping Address", shipX + 3, boxY + 5);

    doc.setFont("Inter-Regular", "normal");
    doc.text(custLines, custX + 3, boxY + 10);
    doc.text(shipLines, shipX + 3, boxY + 10);

    y += boxH + 2;

    /* =====================================================
     4️⃣ PRODUCT TABLE
  ===================================================== */

    autoTable(doc, {
      startY: y,
      margin: { left: marginLeft, right: marginRight },
      tableWidth: contentWidth,
      theme: "grid",
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: 1,
        lineWidth: 0.2,
      },
      head: [["#", "Item", "HSN/SAC", "Tax", "Qty", "Rate", "Per", "Amount"]],
      body: data.saleitems.map((it, i) => [
        i + 1,
        it.title,
        it.hsnsac || "-",
        `${it.taxpercentage || 0}%`,
        `${it.quantity}`,
        `₹${formatCurrency(it.baseprice || 0)}`,
        "Nos",
        `₹${formatCurrency(it.lineGrandTotal || 0)}`,
      ]),
    });

    y = doc.lastAutoTable.finalY + 2;

    /* =====================================================
     5️⃣ TAX SUMMARY TABLE
  ===================================================== */

    autoTable(doc, {
      startY: y,
      margin: { left: marginLeft, right: marginRight },
      tableWidth: contentWidth,
      theme: "grid",
      styles: { fontSize: 7 },
      head: [["HSN/SAC", "Taxable Value", "CGST 9%", "SGST 9%", "Total Tax"]],
      body: data.saleitems.map((it) => [
        it.hsnsac || "-",
        `₹${formatCurrency(it.lineTotalBasePrice || 0)}`,
        `₹${formatCurrency(it.cgstamount || 0)}`,
        `₹${formatCurrency(it.sgstamount || 0)}`,
        `₹${formatCurrency((it.cgstamount || 0) + (it.sgstamount || 0))}`,
      ]),
    });

    y = doc.lastAutoTable.finalY + 6;

    /* =====================================================
     6️⃣ TOTALS RIGHT SIDE
  ===================================================== */

    const valueX = pageW - marginRight - 2;
    const labelX = valueX - 40;

    doc.setFont("Inter-Regular", "normal");

    doc.text("Taxable Amount", labelX, y, { align: "right" });
    doc.text(`₹${formatCurrency(data.totalbaseprice || 0)}`, valueX, y, {
      align: "right",
    });
    y += 5;

    doc.text("CGST", labelX, y, { align: "right" });
    doc.text(`₹${formatCurrency(data.cgstamount || 0)}`, valueX, y, {
      align: "right",
    });
    y += 5;

    doc.text("SGST", labelX, y, { align: "right" });
    doc.text(`₹${formatCurrency(data.sgstamount || 0)}`, valueX, y, {
      align: "right",
    });
    y += 5;

    doc.setFont("Inter-Bold", "bold");
    doc.text("Total", labelX, y, { align: "right" });
    doc.text(`₹${formatCurrency(data.grandtotal || 0)}`, valueX, y, {
      align: "right",
    });

    y += 8;

    /* =====================================================
     7️⃣ BANK / QR / SIGNATURE BLOCK
  ===================================================== */

    const footerH = 35;
    doc.rect(marginLeft, y, contentWidth, footerH);

    const colW = contentWidth / 3;

    doc.line(marginLeft + colW, y, marginLeft + colW, y + footerH);
    doc.line(marginLeft + colW * 2, y, marginLeft + colW * 2, y + footerH);

    doc.setFont("Inter-Bold", "bold");
    doc.text("Bank Details", marginLeft + 3, y + 5);

    doc.setFont("Inter-Regular", "normal");
    doc.text(`Bank: ${data?.bankname || ""}`, marginLeft + 3, y + 10);
    doc.text(`Account #: ${data?.accountnumber || ""}`, marginLeft + 3, y + 14);
    doc.text(`IFSC: ${data?.ifsc || ""}`, marginLeft + 3, y + 18);

    doc.text(
      "Authorized Signatory",
      marginLeft + colW * 2 + 3,
      y + footerH - 5,
    );

    y += footerH + 2;

    /* =====================================================
     8️⃣ NOTES & TERMS
  ===================================================== */

    const bottomH = 30;
    const bottomW = (contentWidth - 2) / 2;

    doc.rect(marginLeft, y, bottomW, bottomH);
    doc.rect(marginLeft + bottomW + 2, y, bottomW, bottomH);

    doc.setFont("Inter-Bold", "bold");
    doc.text("Notes", marginLeft + 3, y + 5);
    doc.text("Terms & Conditions", marginLeft + bottomW + 5, y + 5);

    doc.setFont("Inter-Regular", "normal");

    if (data?.notes) {
      const noteLines = doc.splitTextToSize(data.notes, bottomW - 6);
      doc.text(noteLines, marginLeft + 3, y + 10);
    }

    if (terms) {
      const termLines = doc.splitTextToSize(terms, bottomW - 6);
      doc.text(termLines, marginLeft + bottomW + 5, y + 10);
    }

    return doc;
  };

  const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const ensureSpace = (
      doc,
      currentY,
      requiredHeight,
      topMargin = 10,
      bottomMargin = 10,
    ) => {
      const pageH = doc.internal.pageSize.getHeight();
      if (currentY + requiredHeight > pageH - bottomMargin) {
        doc.addPage();
        return topMargin;
      }
      return currentY;
    };

    const drawLabelValue = (
      doc,
      label,
      value,
      x,
      y,
      maxWidth,
      lh,
      labelBold = true, // 👈 default bold
    ) => {
      if (!value) return y;

      const labelText = `${label}: `;

      doc.setFont(
        labelBold ? "Inter-Bold" : "Inter-Regular",
        labelBold ? "bold" : "normal",
      );

      const labelWidth = doc.getTextWidth(labelText);
      doc.text(labelText, x, y);

      doc.setFont("Inter-Regular", "normal");
      const wrapped = doc.splitTextToSize(value, maxWidth - labelWidth);
      doc.text(wrapped, x + labelWidth, y);

      return y + wrapped.length * lh;
    };

    /* -------------------------------------------------
     HEADER (AUTO HEIGHT)
  ------------------------------------------------- */
    const borderColor = "#C0C0C0";
    const headerY = 8;

    const leftBoxX = 8;
    const leftBoxW = 110; //  reduced width
    const rightBoxX = leftBoxX + leftBoxW + 2;
    const rightBoxW = pageW - rightBoxX - 8;

    const titleHeight = 8;
    const lh = 3.8;

    const headerPaddingTop = 2;
    const headerPaddingBottom = 1;

    const contentX = leftBoxX + 32;
    const maxTextWidth = leftBoxW - 34;

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );

    let tempHeight = headerPaddingTop + titleHeight;

    // company name font size effect
    if (address) {
      tempHeight += doc.splitTextToSize(address, maxTextWidth).length * lh;
    }

    [
      globalData?.salefrom?.phone,
      globalData?.salefrom?.email,
      globalData?.salefrom?.gstnumber,
      globalData?.salefrom?.fssai,
      globalData?.salefrom?.cin,
      globalData?.salefrom?.pannumber,
    ].forEach((v) => {
      if (v) tempHeight += lh;
    });

    tempHeight += headerPaddingBottom;
    const logoBlockHeight = globalData?.salefrom?.image
      ? headerPaddingTop + 18 + headerPaddingBottom
      : 0;

    const metaRowHeight = 6; // each row height
    const metaTopSpacing = 5; // space from top before first row
    const metaRows = 5; // Invoice#, Date, POS, Due Date, Sales Person
    const rightMinHeight = metaTopSpacing + metaRows * metaRowHeight + 1;

    // ---- Final Header Height ---- //
    const headerH = Math.max(tempHeight, logoBlockHeight, rightMinHeight) - 1;

    // LEFT HEADER BOX
    const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];
      const h = hex.replace("#", "");
      return [
        parseInt(h.substring(0, 2), 16),
        parseInt(h.substring(2, 4), 16),
        parseInt(h.substring(4, 6), 16),
      ];
    };

    const [r, g, b] = hexToRgb(borderColor);

    // Apply border color
    doc.setDrawColor(r, g, b);
    doc.setLineWidth(0.3);
    doc.rect(leftBoxX, headerY, leftBoxW, headerH);

    // LOGO

    if (globalData?.salefrom?.image) {
      try {
        const imagePath = globalData.imagePath;

        // Convert to base64
        const base64 = await urlToBase64(imagePath);

        // Natural dimensions
        const { width, height } = await loadImageDimensions(base64);

        // 🔥 Max logo area inside header box
        const maxWidth = 26;
        const maxHeight = headerH - 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);
        imgW *= ratio;
        imgH *= ratio;

        // Detect format
        const ext = imagePath.split(".").pop().toLowerCase();
        const format =
          ext === "png"
            ? "PNG"
            : ext === "jpg" || ext === "jpeg"
              ? "JPEG"
              : "JPEG";

        // Draw image
        doc.addImage(base64, format, leftBoxX + 2, headerY + 5, imgW, imgH);
      } catch (err) {
        console.warn("Logo load failed:", err);
      }
    }

    // COMPANY NAME
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.text(
      globalData?.salefrom?.title || "",
      contentX,
      headerY + headerPaddingTop + 4,
    );

    // COMPANY DETAILS
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    let cty = headerY + headerPaddingTop + titleHeight;
    if (address) {
      doc.setFont("Inter-Regular", "normal");
      const addrLines = doc.splitTextToSize(address, maxTextWidth);
      doc.text(addrLines, contentX, cty);
      cty += addrLines.length * lh;
    }

    // CONTACT & TAX INFO
    cty = drawLabelValue(
      doc,
      "Phone",
      globalData?.salefrom?.phone,
      contentX,
      cty,
      maxTextWidth,
      lh,
      false, // 👈 normal
    );

    cty = drawLabelValue(
      doc,
      "Email",
      globalData?.salefrom?.email,
      contentX,
      cty,
      maxTextWidth,
      lh,
      false, // 👈 normal
    );

    cty = drawLabelValue(
      doc,
      "GST",
      globalData?.salefrom?.gstnumber,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "FSSAI",
      globalData?.salefrom?.fssai,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "CIN",
      globalData?.salefrom?.cin,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    cty = drawLabelValue(
      doc,
      "PAN",
      globalData?.salefrom?.pannumber,
      contentX,
      cty,
      maxTextWidth,
      lh,
      true,
    );

    // RIGHT HEADER BOX
    doc.rect(rightBoxX, headerY, rightBoxW, headerH);
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);

    // Decide title text
    const invoiceText =
      globalData.status === "CANCELLED"
        ? "CANCELLED"
        : globalData.salemode
          ? formatTrackMode(globalData.salemode) // eg: TAX INVOICE
          : "";

    // Optional: make CANCELLED stand out
    if (globalData.status === "CANCELLED") {
      doc.setTextColor(200, 0, 0); // red
    }

    doc.text(invoiceText, rightBoxX + rightBoxW - 2, headerY + 3, {
      align: "right",
    });

    // reset color for rest of document
    doc.setTextColor(0, 0, 0);

    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;

    const meta = [
      ["Bill No", globalData.saleno],
      ["Date", invDate],
      ["Place Of Supply", globalData?.salefrom?.state || "-"],
      ["Due Date", invDate],
      ["Sales Person", globalData.salesperson || ""],
    ];

    let my = headerY + 5;
    meta.forEach(([k, v]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text(k, rightBoxX + 2, my);
      doc.text(":", rightBoxX + 30, my);

      doc.setFont("Inter-Regular", "normal");
      doc.text(String(v || "-"), rightBoxX + 34, my);
      my += 6;
    });

    /* -------------------------------------------------
     CUSTOMER & SHIPPING (AUTO HEIGHT)
  ------------------------------------------------- */
    const pagePadding = 8;
    const gapBetweenBoxes = 2;
    const innerPadding = 2;
    const titleGap = 4; // space below title

    // total available width
    const availableWidth = pageW - pagePadding * 2 - gapBetweenBoxes;
    const boxWidth = availableWidth / 2;

    //  separate variables (no conflict with header)
    const custBoxX = pagePadding;
    const custBoxW = boxWidth;

    const shipBoxX = custBoxX + custBoxW + gapBetweenBoxes;
    const shipBoxW = boxWidth;

    const boxY = headerY + headerH + 2;
    let tableStartY;

    const hasSaleTo =
      globalData?.saleto &&
      (globalData.saleto.name ||
        globalData.saleto.addressline1 ||
        globalData.saleto.addressline2 ||
        globalData.saleto.district ||
        globalData.saleto.state ||
        globalData.saleto.pincode ||
        globalData.saleto.gstnumber);

    if (hasSaleTo && optData.isCustomerDisplay) {
      const lineHeight = 3;

      const innerTextWidthLeft = custBoxW - 4;
      const innerTextWidthRight = shipBoxW - 4;

      // ---------- CUSTOMER TEXT

    const custLoc = [
      [globalData?.saleto?.district, globalData?.saleto?.state].filter(Boolean).join(", "),
      globalData?.saleto?.pincode
    ].filter(Boolean).join(" - ");
    const addressStr = joinAddress(
      globalData?.saleto?.addressline1,
      globalData?.saleto?.addressline2,
    );
    const customerText = [
      globalData?.saleto?.name && { label: null, value: globalData.saleto.name },
      addressStr && { label: null, value: addressStr },
      custLoc && { label: null, value: custLoc },
      globalData?.saleto?.phone && { label: "Phone", value: globalData.saleto.phone },
      globalData?.saleto?.email && { label: "Email", value: globalData.saleto.email },
      globalData?.saleto?.referenceid && { label: "Reference No", value: globalData.saleto.referenceid },
      globalData?.saleto?.gstnumber && { label: "GSTIN", value: globalData.saleto.gstnumber },
      globalData?.saleto?.fssai && { label: "FSSAI", value: globalData.saleto.fssai }, 
      globalData?.saleto?.pannumber && { label: "PAN", value: globalData.saleto.pannumber },
      globalData?.saleto?.cinnumber && { label: "CIN", value: globalData.saleto.cinnumber },
    ].filter((item) => Boolean(item && item.value && String(item.value).trim()));
          // const customerText = [
      //   { label: null, value: globalData?.saleto?.name },
      //   {
      //     label: null,
      //     value: joinAddress(
      //       globalData?.saleto?.addressline1,
      //       globalData?.saleto?.addressline2,
      //     ),
      //   },
      //   {
      //     label: null,
      //     value: `${globalData?.saleto?.district}, ${globalData?.saleto?.state} - ${globalData?.saleto?.pincode}`,
      //   },
      //   globalData?.saleto?.phone && {
      //     label: "Phone",
      //     value: globalData.saleto.phone,
      //   },
      //   globalData?.saleto?.email && {
      //     label: "Email",
      //     value: globalData.saleto.email,
      //   },
      //   globalData?.saleto?.referenceid && {
      //     label: "Reference No ",
      //     value: globalData.saleto.referenceid,
      //   },
      //   globalData?.saleto?.gstnumber && {
      //     label: "GSTIN",
      //     value: globalData.saleto.gstnumber,
      //   },
      //   globalData?.saleto?.fssai && {
      //     label: "FASSI",
      //     value: globalData.saleto.fssai,
      //   },
      //   globalData?.saleto?.pannumber && {
      //     label: "PAN",
      //     value: globalData.saleto.pannumber,
      //   },
      //   globalData?.saleto?.cinnumber && {
      //     label: "CIN",
      //     value: globalData.saleto.cinnumber,
      //   },
      // ].filter(Boolean);

    let customerLineCount = 0;
      customerText.forEach((item) => {
        const textToWrap = item.label ? `${item.label} : ${item.value}` : String(item.value);
        customerLineCount += wrapText(doc, textToWrap, innerTextWidthLeft).length;
      });
     
     const ship = globalData?.saleto?.shippingAddress;
     const shipLoc = [
         [ship?.district, ship?.city, ship?.state, ship?.country].filter(Boolean).join(", "),
            ship?.pincode
        ].filter(Boolean).join(" - ");
    const shippingText = [
      globalData?.saleto?.shippingAddress?.name,
      joinAddress(
        globalData?.saleto?.shippingAddress?.addressline1,
        globalData?.saleto?.shippingAddress?.addressline2,
      ),
      shipLoc,
      globalData?.transport || "",
    ].filter((val) => Boolean(val && String(val).trim()));

      let shippingLines = [];
      shippingText.forEach((t) => {
        shippingLines.push(...wrapText(doc, t, innerTextWidthRight));
      });
      const shippingLineCount = shippingLines.length;

      // ---------- HEIGHT CALCULATION ----//
      const contentStartOffset = innerPadding + 2 + titleGap;

      const custBoxH = contentStartOffset + customerLineCount * lineHeight + 2;

      const shipBoxH = contentStartOffset + shippingLineCount * lineHeight + 2;

      const boxH = Math.max(custBoxH, shipBoxH);

      // ---------- CUSTOMER BOX

      doc.rect(custBoxX, boxY, custBoxW, boxH);

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text(
        "Customer Details",
        custBoxX + innerPadding,
        boxY + innerPadding + 3,
      );

      let cy = boxY + innerPadding + 3 + titleGap;
      const boldLabels = ["GSTIN", "FASSI", "PAN", "CIN"];

      customerText.forEach((item, idx) => {
        if (!item.label) {
          doc.setFont(
            idx === 0 ? "Inter-Bold" : "Inter-Regular",
            idx === 0 ? "bold" : "normal",
          );
          // name / address
          const lines = wrapText(doc, item.value, innerTextWidthLeft);
          lines.forEach((line) => {
            doc.text(line, custBoxX + innerPadding, cy);
            cy += lineHeight;
          });
        } else {
          const isBold = boldLabels.includes(item.label);

          // label
          doc.setFont(
            isBold ? "Inter-Bold" : "Inter-Regular",
            isBold ? "bold" : "normal",
          );
          doc.text(`${item.label} :`, custBoxX + innerPadding, cy);

          const labelW = doc.getTextWidth(`${item.label} : `);

          // value always normal
          doc.setFont("Inter-Regular", "normal");
          doc.text(item.value, custBoxX + innerPadding + labelW, cy);

          cy += lineHeight;
        }
      });

      // ---------- SHIPPING BOX

      if (
        globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2
      ) {
        doc.rect(shipBoxX, boxY, shipBoxW, boxH);
        doc.setFont("Inter-Bold", "bold");
        doc.text(
          "Shipping Address",
          shipBoxX + innerPadding,
          boxY + innerPadding + 3,
        );

        doc.setFont("Inter-Regular", "normal");
        let sy = boxY + innerPadding + 4 + titleGap;

        shippingLines.forEach((line) => {
          doc.text(line, shipBoxX + innerPadding, sy);
          sy += lineHeight;
        });
      }
      tableStartY = boxY + boxH + 2;
    } else {
      tableStartY = boxY;
    }

    /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
    autoTable(doc, {
      startY: tableStartY,
      theme: "grid",
      margin: { left: 8, right: 5 },
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: 1,
        valign: "middle",
        overflow: "linebreak",
        lineWidth: 0.2,
        textColor: "#000000",
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 7,
        halign: "center",
        valign: "middle",
        cellPadding: 0.8,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
      },
      head: [
        [
          "S.No",
          "Description",
          "HSN/SAC",
          "MRP",
          "Discount",
          "Rate",
          "Qty",
          "Amount",
        ],
      ],
      body: globalData.saleitems.map((it, i) => {
        const amount = it.lineGrandTotal;
        const mrp = it.mrp;
        const Discount = it.discount;
        const rate = it.soldprice;
        const landingCost = it.lineTotalLandingCost;

        return [
          i + 1,
          [it.title, it.note ? `-(${it.note})` : ""].filter(Boolean),
          it.hsnsac || "",
          `₹${mrp}`,
          `₹${Discount}`,
          `₹${rate}`,
          `${it.quantity} ${(() => {
            const unitCode = it?.isSecondaryUnit
              ? it?.unitConfig?.secondaryUnitCode
              : it?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          `₹${amount}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 84, halign: "left" },
        2: { cellWidth: 16, halign: "center" },
        3: { cellWidth: 18, halign: "right" },
        4: { cellWidth: 18, halign: "right" },
        5: { cellWidth: 18, halign: "right" },
        6: { cellWidth: 12, halign: "center" },
        7: { cellWidth: 18, halign: "right" },
        8: { cellWidth: 18, halign: "right" },
      },
    });

    /* -------------------------------------------------
     TOTALS
  ------------------------------------------------- */
    const grantotal = CurrencyConverter.toCurrency(data.grandtotal || 0, "INR");

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }

    let leftY = doc.lastAutoTable.finalY + 4;
    let rightY = doc.lastAutoTable.finalY + 4;

    const valueX = pageW - 8;
    const labelX = valueX - 25;
    rightY = ensureSpace(doc, rightY, 35);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    // Grand Total
    doc.setFont("Inter-Bold", "bold");
    doc.text("Total Amount :", labelX, rightY, { align: "right" });
    doc.text(`₹${formatCurrency(grantotal)}`, valueX, rightY, {
      align: "right",
    });
    rightY += 8;

    rightY = ensureSpace(doc, rightY, 25);
    const signBlockY = rightY;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 40;
        const maxHeight = 10;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          pageW - 8 - imgW,
          signBlockY,
          imgW,
          imgH,
        );
      } catch {
        console.warn("Signature load failed");
      }
    }

    doc.setFont("Inter-Regular", "normal");
    doc.text("Issued By, Signature", pageW - 8, signBlockY + 14, {
      align: "right",
    });

    doc.setFont("Inter-Bold", "bold");
    doc.text(data?.salefrom?.title || "", pageW - 8, signBlockY + 18, {
      align: "right",
    });

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text("Total Items :", leftBoxX, leftY);
    doc.text(String(data.totalItems), leftBoxX + 20, leftY);
    leftY += 4;

    leftY = ensureSpace(doc, leftY, 30);
    if (paymentRows.length > 0 && optData?.isPayment) {
      autoTable(doc, {
        startY: leftY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 8 },
        tableWidth: 50,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 1,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 30, halign: "left" },
          1: { cellWidth: 20, halign: "right" },
        },
        theme: "grid",
      });

      leftY = doc.lastAutoTable.finalY + 5;
    } else {
      leftY += 5;
    }
    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
      leftY = ensureSpace(doc, leftY, 35);
      const bankX = leftBoxX;
      const qrSize = 28;
      const gap = 8;
      let bankY = leftY + 5;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", bankX, leftY);

      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18;
      let maxWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(`${item.label} :`, bankX, bankY);

        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), bankX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxWidth = Math.max(maxWidth, completeLineWidth);

        bankY += 4.5;
      });
      doc.setTextColor(0, 0, 0);

      if (qrCodeDataUrl) {
        const qrX = bankX + maxWidth + gap;
        const qrY = leftY - 2;

        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      leftY = Math.max(bankY, leftY + qrSize);
    }
    if (optData?.isRemark && globalData?.remark) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(72, 72, 72);

      const innerPaddingX = 2;
      // Spans across the full printable width of the page

      const remarkWidth = (pageW - leftBoxX * 2) * 0.65; // 65% of printable width
      const maxTextWidth = remarkWidth - innerPaddingX * 2;
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(globalData.remark),
        maxTextWidth,
      );

      const textLineHeight = 3.5;
      const boxPaddingTop = 2.5;
      const boxPaddingBottom = 2.5;

      const remarkHeight =
        boxPaddingTop + remarkLines.length * textLineHeight + boxPaddingBottom;

      // Ensure there's room on the page for the full-width block
      leftY = ensureSpace(doc, leftY, remarkHeight + 6);
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0);
      doc.text("Remark", leftBoxX, leftY);

      const boxStartY = leftY + 2;

      // Draw the full-width tight rounded container box
      doc.setDrawColor(180);
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0);

      let remarkY = boxStartY + boxPaddingTop;

      remarkLines.forEach((line) => {
        doc.text(line, leftBoxX, remarkY);
        remarkY += textLineHeight;
      });

      // Push vertical tracker below the full-row remark box
      leftY = boxStartY + remarkHeight;
    }
    if (terms?.length > 0) {
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      const termLines = doc.splitTextToSize(terms, pageW / 2 - 12);

      const termsHeight = termLines.length * 3.5 + 6;

      leftY = ensureSpace(doc, leftY, termsHeight);

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Terms & Conditions", leftBoxX, leftY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.text(termLines, leftBoxX, leftY + 4);

      leftY += termsHeight;
    }

    // draw table ONLY if rows exist

    if (storeSettings?.negobillBranding) {
      const y = pageH - 5;
      const rightX = pageW - 5;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");
      const boldW = doc.getTextWidth(boldText);

      const totalW = normalW + boldW;

      // Start X so whole string is right-aligned
      const startX = rightX - totalW;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, y);

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + normalW, y);
    }
    setDownload(false);
    return doc;
  };

  const generateInvoice2 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    /* -------------------------------------------------
     HEADER (AUTO HEIGHT)
  ------------------------------------------------- */
    const borderColor = "#C0C0C0";
    const headerY = 8;

    const leftBoxX = 8;
    const leftBoxW = 110; // ⬅️ reduced width
    const rightBoxX = leftBoxX + leftBoxW + 2;
    const rightBoxW = pageW - rightBoxX - 8;

    const titleLH = 5;
    const lh = 3.8;

    const headerPaddingTop = 2;
    const headerPaddingBottom = 1;

    const compLines = [
      joinAddress(data?.salefrom?.addressline1, data?.salefrom?.addressline2),
      `${data?.salefrom?.district}, ${data?.salefrom?.state} - ${data?.salefrom?.pincode}`,
      `CIN : ${data?.salefrom?.cin || ""}`,
      `PAN : ${data?.salefrom?.pannumber}`,
      `Mobile : ${data?.salefrom?.phone}`,
      `GSTIN : ${data?.salefrom?.gstnumber}`,
    ].filter(Boolean);

    const titleHeight = 8; // company name font size effect
    const companyTextHeight =
      headerPaddingTop +
      titleHeight +
      compLines.length * lh +
      headerPaddingBottom;
    const logoBlockHeight = data?.salefrom?.image
      ? headerPaddingTop + 18 + headerPaddingBottom
      : 0;

    const headerH = Math.max(companyTextHeight, logoBlockHeight);

    // LEFT HEADER BOX
    const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];
      const h = hex.replace("#", "");
      return [
        parseInt(h.substring(0, 2), 16),
        parseInt(h.substring(2, 4), 16),
        parseInt(h.substring(4, 6), 16),
      ];
    };

    const [r, g, b] = hexToRgb(borderColor);

    // Apply border color
    doc.setDrawColor(r, g, b);
    doc.setLineWidth(0.3);
    doc.rect(leftBoxX, headerY, leftBoxW, headerH);

    // LOGO

    if (data?.salefrom?.image) {
      try {
        const imagePath = uRLs.IMAGE_URL + "profile/" + data.salefrom.image;

        // Convert to base64
        const base64 = await urlToBase64(imagePath);

        // Natural dimensions
        const { width, height } = await loadImageDimensions(base64);

        // 🔥 Max logo area inside header box
        const maxWidth = 26;
        const maxHeight = headerH - 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);
        imgW *= ratio;
        imgH *= ratio;

        // Detect format
        const ext = imagePath.split(".").pop().toLowerCase();
        const format =
          ext === "png"
            ? "PNG"
            : ext === "jpg" || ext === "jpeg"
              ? "JPEG"
              : "JPEG";

        // Draw image
        doc.addImage(base64, format, leftBoxX + 2, headerY + 5, imgW, imgH);
      } catch (err) {
        console.warn("Logo load failed:", err);
      }
    }

    // COMPANY NAME
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text(
      data.salefrom.title,
      leftBoxX + 32,
      headerY + headerPaddingTop + 4,
    );

    // COMPANY DETAILS
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8.5);

    let cty = headerY + headerPaddingTop + titleHeight;
    compLines.forEach((l) => {
      doc.text(l, leftBoxX + 32, cty);
      cty += lh;
    });

    // RIGHT HEADER BOX
    doc.rect(rightBoxX, headerY, rightBoxW, headerH);

    const invDate = DateConverter.ISOToDisplayFormat(data?.saledate).date;

    let my = headerY + 5;
    const colGap = 4;
    const colW = (rightBoxW - colGap) / 2;

    const col1X = rightBoxX + 2;
    const col2X = col1X + colW + colGap;

    // ---------------- Row 1 : Invoice + Date
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Invoice #", col1X, my);
    doc.text("Date", col2X, my);

    doc.setFont("Inter-Regular", "normal");
    doc.text(data.saleno || "-", col1X, my + 4);
    doc.text(invDate || "-", col2X, my + 4);

    my += 11;

    // ---------------- Row 2 : Place of Supply + Due Date
    doc.setFont("Inter-Bold", "bold");
    doc.text("Place Of Supply", col1X, my);
    doc.text("Due Date", col2X, my);

    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.salefrom?.state || "-", col1X, my + 4);
    doc.text(invDate || "-", col2X, my + 4);

    my += 11;

    // ---------------- Row 3 : Sales Person (full width)
    doc.setFont("Inter-Bold", "bold");
    doc.text("Sales Person", col1X, my);

    doc.setFont("Inter-Regular", "normal");
    doc.text(data.salesperson || "-", col1X, my + 4);

    /* -------------------------------------------------
     CUSTOMER & SHIPPING (AUTO HEIGHT)
  ------------------------------------------------- */
    const pagePadding = 8;
    const gapBetweenBoxes = 2;
    const innerPadding = 2;
    const titleGap = 4; // space below title

    // total available width
    const availableWidth = pageW - pagePadding * 2 - gapBetweenBoxes;
    const boxWidth = availableWidth / 2;

    // ✅ separate variables (no conflict with header)
    const custBoxX = pagePadding;
    const custBoxW = boxWidth;

    const shipBoxX = custBoxX + custBoxW + gapBetweenBoxes;
    const shipBoxW = boxWidth;

    const boxY = headerY + headerH + 2;
    let tableStartY;

    const hasSaleTo =
      data?.saleto &&
      (data.saleto.name ||
        data.saleto.addressline1 ||
        data.saleto.addressline2 ||
        data.saleto.district ||
        data.saleto.state ||
        data.saleto.pincode ||
        data.saleto.gstnumber);

    if (hasSaleTo) {
      const innerPaddingX = 2;
      const lineHeight = 3;

      const innerTextWidthLeft = custBoxW - 4;
      const innerTextWidthRight = shipBoxW - 4;

      // ---------- CUSTOMER TEXT
      const customerText = [
        data?.saleto?.name,
        joinAddress(data?.saleto?.addressline1, data?.saleto?.addressline2),
        `${data?.saleto?.district}, ${data?.saleto?.state} - ${data?.saleto?.pincode}`,
        data?.saleto?.phone ? `Phone : ${data.saleto.phone}` : "",
        data?.saleto?.email ? `Email : ${data.saleto.email}` : "",
        data?.saleto?.gstnumber ? `GSTIN : ${data.saleto.gstnumber}` : "",
        data?.saleto?.pannumber ? `PAN : ${data.saleto.pannumber}` : "",
        data?.saleto?.cinnumber ? `CIN : ${data.saleto.cinnumber}` : "",
      ].filter(Boolean);

      let customerLines = [];
      customerText.forEach((t) => {
        customerLines.push(...wrapText(doc, t, innerTextWidthLeft));
      });

      // ---------- SHIPPING TEXT
      const shippingText = [
        data?.saleto?.name,
        joinAddress(data?.saleto?.addressline1, data?.saleto?.addressline2),
        `${data?.saleto?.district}, ${data?.saleto?.state}`,
        data?.transport || "",
      ].filter(Boolean);

      let shippingLines = [];
      shippingText.forEach((t) => {
        shippingLines.push(...wrapText(doc, t, innerTextWidthRight));
      });

      // ---------- HEIGHT
      const customerTextStartY = boxY + innerPadding + 1 + titleGap;
      const shippingTextStartY = boxY + innerPadding + 1 + titleGap;
      const customerTextHeight = customerLines.length * lineHeight;
      const shippingTextHeight = shippingLines.length * lineHeight;
      const custBoxH = customerTextStartY - boxY + customerTextHeight + 1;

      const shipBoxH = shippingTextStartY - boxY + shippingTextHeight + 1;
      const boxH = Math.max(custBoxH, shipBoxH);

      // ---------- CUSTOMER BOX
      doc.rect(custBoxX, boxY, custBoxW, boxH);
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text(
        "Customer Details",
        custBoxX + innerPadding,
        boxY + innerPadding + 3,
      );

      doc.setFont("Inter-Regular", "normal");
      let cy = boxY + innerPadding + 3 + titleGap;
      customerLines.forEach((line) => {
        doc.text(line, custBoxX + innerPaddingX, cy);
        cy += lineHeight;
      });

      // ---------- SHIPPING BOX
      doc.rect(shipBoxX, boxY, shipBoxW, boxH);
      doc.setFont("Inter-Bold", "bold");
      doc.text(
        "Shipping Address",
        shipBoxX + innerPadding,
        boxY + innerPadding + 3,
      );

      doc.setFont("Inter-Regular", "normal");
      let sy = boxY + innerPadding + 3 + titleGap;
      shippingLines.forEach((line) => {
        doc.text(line, shipBoxX + innerPaddingX, sy);
        sy += lineHeight;
      });

      tableStartY = boxY + boxH + 2;
    } else {
      tableStartY = boxY;
    }

    /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
    autoTable(doc, {
      startY: tableStartY,
      theme: "grid",
      margin: { left: 8, right: 5 },
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: 1,
        valign: "middle",
        overflow: "linebreak",
        lineWidth: 0.2,
        textColor: "#000000",
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 7,
        halign: "center",
        valign: "middle",
        cellPadding: 0.8,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
      },
      head: [
        [
          "S.No",
          "Description",
          "HSN/SAC",
          "MRP",
          "Discount",
          "Sale Price",
          "Qty",
          "Rate",
          "Tax",
          "Tax Amount",
          "Total",
        ],
      ],
      body: data.saleitems.map((it, i) => {
        const TaxAmount = CurrencyConverter.toCurrency(
          it.lineTotalTaxAmount || 0,
          "INR",
        );
        const saleprice = CurrencyConverter.toCurrency(
          it.soldprice || 0,
          "INR",
        );
        const amount = CurrencyConverter.toCurrency(
          it.lineTotalSoldPrice || 0,
          "INR",
        );
        const mrp = CurrencyConverter.toCurrency(it.mrp || 0, "INR");
        const discount = CurrencyConverter.toCurrency(it.discount || 0, "INR");
        const Rate = CurrencyConverter.toCurrency(it.baseprice || 0, "INR");
        return [
          i + 1,
          it.title,
          it.hsnsac || "",
          `₹${formatCurrency(mrp)}`,
          `₹${formatCurrency(discount)}`,
          `₹${formatCurrency(saleprice)}`,
          `${it.quantity}`,
          `₹${formatCurrency(Rate)}`,
          `${it.taxpercentage || "-"}%`,
          `₹${formatCurrency(TaxAmount)}`,
          `₹${formatCurrency(amount)}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 9, halign: "center" }, // S.No
        1: { cellWidth: 52, halign: "left" }, // Description ⬅️ reduced
        2: { cellWidth: 16, halign: "center" }, // HSN
        3: { cellWidth: 17, halign: "right" }, // MRP
        4: { cellWidth: 16, halign: "right" }, // Discount
        5: { cellWidth: 17, halign: "right" }, // Sale Price
        6: { cellWidth: 9, halign: "center" }, // Qty
        7: { cellWidth: 16, halign: "right" }, // Rate
        8: { cellWidth: 9, halign: "center" }, // Tax
        9: { cellWidth: 17, halign: "right" }, // Tax Amount
        10: { cellWidth: 17, halign: "right" }, // Total
      },
    });

    /* -------------------------------------------------
     TOTALS
  ------------------------------------------------- */
    const isInterState =
      data.salefrom?.statecode &&
      data.saleto?.statecode &&
      data.salefrom.statecode !== data.saleto.statecode;

    const igst = CurrencyConverter.toCurrency(data.igstamount || 0, "INR");
    const sgst = CurrencyConverter.toCurrency(data.sgstamount || 0, "INR");
    const cgst = CurrencyConverter.toCurrency(data.cgstamount || 0, "INR");
    const linetotalbaseprice = CurrencyConverter.toCurrency(
      data.totalbaseprice || 0,
      "INR",
    );
    const grantotal = CurrencyConverter.toCurrency(data.grandtotal || 0, "INR");

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");

    // condition based rows
    if (cashAmt > 0) {
      paymentRows.push([
        "Cash",
        `₹${formatCurrency(cashAmt, "INR", false, true)}`,
      ]);
    }

    if (cardAmt > 0) {
      paymentRows.push([
        "Card",
        `₹${formatCurrency(cardAmt, "INR", false, true)}`,
      ]);
    }

    if (onlineAmt > 0) {
      paymentRows.push([
        "Online Amount",
        `₹${formatCurrency(onlineAmt, "INR", false, true)}`,
      ]);
    }

    if (upiAmt > 0) {
      paymentRows.push([
        "UPI",
        `₹${formatCurrency(upiAmt, "INR", false, true)}`,
      ]);
    }

    if (balanceAmt > 0) {
      paymentRows.push([
        "Balance Due",
        `₹${formatCurrency(balanceAmt, "INR", false, true)}`,
      ]);
    }

    let leftY = doc.lastAutoTable.finalY + 4;
    let rightY = doc.lastAutoTable.finalY + 4;

    const valueX = pageW - 8;
    const labelX = valueX - 25;

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    // Total Taxable
    doc.text("TTotal Amount Before Tax :", labelX, rightY, { align: "right" });
    doc.text(`₹${formatCurrency(linetotalbaseprice)}`, valueX, rightY, {
      align: "right",
    });
    rightY += 5;

    // GST
    if (isInterState) {
      doc.text("IGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${formatCurrency(igst)}`, valueX, rightY, { align: "right" });
      rightY += 5;
    } else {
      doc.text("SGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${formatCurrency(sgst)}`, valueX, rightY, { align: "right" });
      rightY += 5;

      doc.text("CGST :", labelX, rightY, { align: "right" });
      doc.text(`₹${formatCurrency(cgst)}`, valueX, rightY, { align: "right" });
      rightY += 5;
    }

    // Grand Total
    doc.setFont("Inter-Bold", "bold");
    doc.text("Total Amount :", labelX, rightY, { align: "right" });
    doc.text(`₹${formatCurrency(grantotal)}`, valueX, rightY, {
      align: "right",
    });
    rightY += 8;
    const signBlockY = rightY;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 40;
        const maxHeight = 10;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          pageW - 8 - imgW,
          signBlockY,
          imgW,
          imgH,
        );
      } catch {
        console.warn("Signature load failed");
      }
    }

    doc.setFont("Inter-Regular", "normal");
    doc.text("Issued By, Signature", pageW - 8, signBlockY + 14, {
      align: "right",
    });

    doc.setFont("Inter-Bold", "bold");
    doc.text(data?.salefrom?.title || "", pageW - 8, signBlockY + 18, {
      align: "right",
    });

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text("Total Items :", leftBoxX, leftY);
    doc.text(String(data.saleitems.length), leftBoxX + 20, leftY);
    leftY += 4;

    if (paymentRows.length > 0) {
      autoTable(doc, {
        startY: leftY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 8 },
        tableWidth: 50,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 1,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 30, halign: "left" },
          1: { cellWidth: 20, halign: "right" },
        },
        theme: "grid",
      });

      leftY = doc.lastAutoTable.finalY + 5;
    }

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Terms & Conditions", leftBoxX, leftY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.text(terms, leftBoxX, leftY + 4, {
        maxWidth: pageW / 2 - 12,
      });
    }

    // draw table ONLY if rows exist

    if (storeSettings?.negobillBranding) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("www.NegoBill.com", pageW - 8, pageH - 10, {
        align: "right",
      });
    }
    setDownload(false);
    return doc;
  };

  const generateinvoiceHalfA4PDF = async () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    if (data?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 30;
        const maxHeight = 8;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 14;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = data.salemode && formatTrackMode(data.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (data.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(8);
    const invoiceNoLabel = "Invoice No:";
    const invoiceNoValue = data.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      data.saledate,
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 5;
    const innerGap = 2;
    const invoiceRowY = 18;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    // --- Invoice From (between logo & title, in 2 lines) ---
    const topY = headerY + padding; // logo top
    const bottomY = invoiceTextY; // invoice title baseline
    const middleY = topY + (bottomY - topY) / 2; // midpoint

    // Line 1: Company + Address
    const line1 = [
      data.salefrom?.title || "-",
      [
        data.salefrom?.addressline1,
        data.salefrom?.addressline2,
        data.salefrom?.district,
        data.salefrom?.country,
        data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
      ]
        .filter(Boolean)
        .join(", "),
    ]
      .filter(Boolean)
      .join(", ");

    // Line 2: Phone + Email + GST + PAN + State
    const line2 = [
      data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
      data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
      data.salefrom?.gstnumber ? `GST: ${data.salefrom.gstnumber}` : "",
      data.salefrom?.fssai ? `FSSAI: ${data.salefrom?.fssai}` : "",
      data.salefrom?.pannumber ? `PAN: ${data.salefrom.pannumber}` : "",
      data.salefrom?.state
        ? `State: ${data.salefrom.state} [Code: ${
            data.salefrom?.statecode || ""
          }]`
        : "",
    ]
      .filter(Boolean)
      .join("  |  ");

    const fromDetails = [line1, line2];

    // Position nicely between logo and title
    const leftX = padding + 35; // shift a bit right of logo
    const rightX = pageWidth - padding - invoiceTextWidth - 10;
    const availableWidth = rightX - leftX;

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    fromDetails.forEach((line, i) => {
      doc.text(
        doc.splitTextToSize(line, availableWidth),
        leftX,
        middleY + i * 5,
      );
    });

    let toY = middleY + fromDetails.length * 10;

    // --- Invoice To ---
    const hasSaleToData =
      data.saleto &&
      (data.saleto.name ||
        data.saleto.addressline1 ||
        data.saleto.addressline2 ||
        data.saleto.district ||
        data.saleto.country ||
        data.saleto.pincode ||
        data.saleto.phone ||
        data.saleto.email ||
        data.saleto.gstnumber ||
        data.saleto.state ||
        data.saleto.statecode ||
        data.saleto.referid);

    if (hasSaleToData) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Invoice To:", padding, toY);

      toY += 5;

      const toDetailsLine = [
        data.saleto?.name || "-",
        [
          data.saleto?.addressline1,
          data.saleto?.addressline2,
          data.saleto?.district,
          data.saleto?.country,
          data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
        ]
          .filter(Boolean)
          .join(", "),
        data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
        data.saleto?.email ? `Email: ${data.saleto.email}` : "",
        data.saleto?.gstnumber ? `GST: ${data.saleto.gstnumber}` : "",
        data.saleto?.state
          ? `State: ${data.saleto.state} [State Code: ${
              data.saleto?.statecode || ""
            }]`
          : "",
        data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(9);
      doc.text(
        doc.splitTextToSize(toDetailsLine, pageWidth - padding * 2),
        padding,
        toY,
      );
    }

    // 3. Product Table
    const productBody = data.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = CurrencyConverter.toCurrency(item.soldprice || 0, "INR");
      const total = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR",
      );
      const gross = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR",
      );
      const taxable = CurrencyConverter.toCurrency(
        item.lineTotalBasePrice || 0,
        "INR",
      );
      const gstAmt = CurrencyConverter.toCurrency(
        item.lineTotalTaxAmount || 0,
        "INR",
      );

      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
        ...(item.discount > 0
          ? [`MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`]
          : []),
        ...(item.discount > 0
          ? [
              `Discount: - ₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR",
              )}`,
            ]
          : []),
        `GST     : ${item.taxpercentage}%`,
      ].join("\n");

      return [
        i + 1,
        desc,
        `₹${rate}`,
        qty,
        `₹${gross}`,
        `₹${taxable}`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: data.totalqty,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalsoldprice || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalbaseprice || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totaltaxamount || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.grandtotal || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);

    const commonTableWidth = doc.internal.pageSize.getWidth() - padding * 2;

    autoTable(doc, {
      startY: Math.max(toY, toY) + 10,
      head: [
        [
          "S.No",
          "Description",
          "Rate",
          "Qty",
          "Gross Amount",
          "Taxable Value",
          "GST Amount",
          "Total",
        ],
      ],
      body: productBody,
      margin: { left: padding, right: padding },
      tableWidth: commonTableWidth, // ✅ same as summary
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        valign: "middle",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        font: "Inter-Bold",
        fontStyle: "bold",
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.06, halign: "center" }, // S.No (6%)
        1: { cellWidth: commonTableWidth * 0.4, halign: "left" }, // 🟢 Description (40%)
        2: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Rate (10%)
        3: { cellWidth: commonTableWidth * 0.07, halign: "center" }, // Qty (7%)
        4: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Gross (10%)
        5: { cellWidth: commonTableWidth * 0.11, halign: "right" }, // Taxable (11%)
        6: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // GST (8%)
        7: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // Total (8%)
      },

      theme: "grid",
    });

    const isInterState =
      data.salefrom?.statecode &&
      data.saleto?.statecode &&
      data.salefrom.statecode !== data.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Total Amount Before Tax",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data.totalbaseprice || 0,
            "INR",
          )}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: data.amountinwords,
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 9,
          },
        },
        {
          content: isInterState ? "IGST" : "SGST",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${CurrencyConverter.toCurrency(
            isInterState ? data.igstamount || 0 : data.sgstamount || 0,
            "INR",
          )}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ],
    ];
    if (!isInterState) {
      body.push([
        { content: "CGST", styles: { halign: "right", fontSize: 9 } },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data.cgstamount || 0,
            "INR",
          )}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ]);
    }
    // Add Total row
    body.push([
      { content: "Total", styles: { halign: "right", fontSize: 9 } },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalsoldprice || 0,
          "INR",
        )}`,
        styles: { halign: "center", valign: "middle", fontSize: 9 },
      },
    ]);
    // Add Grand Total row
    body.push([
      {
        content: "Grand Total (Rounded)",
        styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
      },
      {
        content: `₹ ${CurrencyConverter.toCurrency(
          data.grandtotal || 0,
          "INR",
        )}`,
        styles: {
          halign: "center",
          valign: "middle",
          fontStyle: "bold",
          fontSize: 10,
        },
      },
    ]);
    const afterProductsY = doc.lastAutoTable?.finalY;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 50;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    // ✅ Summary table
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: padding, right: padding },
      tableWidth: commonTableWidth, // ✅ same width as products
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 8,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.56 }, // left block (Amount in Words)
        1: { cellWidth: commonTableWidth * 0.36, halign: "right" }, // reduced width
        2: { cellWidth: commonTableWidth * 0.08, halign: "center" }, // slightly wider for values
      },

      didParseCell: function (data) {
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 10;

    if (parseFloat(data?.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(
        `Your Total Discount : ₹${CurrencyConverter.toCurrency(
          data?.totaldiscount || 0,
          "INR",
        )}`,
        105,
        currentY,
        { align: "center" },
      );

      currentY += 2; // ONLY if discount exists
    }
    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------
    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    // condition based rows
    if (cashPaid > 0) {
      paymentRows.push([
        "Cash",
        `₹${CurrencyConverter.toCurrency(cashPaid, "INR")}`,
      ]);
    }

    if (cardPaid > 0) {
      paymentRows.push([
        "Card",
        `₹${CurrencyConverter.toCurrency(cardPaid, "INR")}`,
      ]);
    }

    if (onlinePaid > 0) {
      paymentRows.push([
        "Online Amount",
        `₹${CurrencyConverter.toCurrency(onlinePaid, "INR")}`,
      ]);
    }

    if (upiPaid > 0) {
      paymentRows.push([
        "UPI",
        `₹${CurrencyConverter.toCurrency(upiPaid, "INR")}`,
      ]);
    }

    if (balanceDue > 0) {
      paymentRows.push([
        "Balance Due",
        `₹${CurrencyConverter.toCurrency(balanceDue, "INR")}`,
      ]);
    }

    // draw table ONLY if rows exist
    if (paymentRows?.length > 0) {
      autoTable(doc, {
        startY: currentY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    }

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", 10, currentY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.text(terms, 13, currentY + 4);
    }

    const rightXs = pageWidth - padding;

    const boxTopY = currentY + 3;
    // const boxTopY = footerY + 7;
    const boxHeight = 20;
    const boxLeftX = padding;
    const boxRightX = pageWidth - padding;
    const boxWidth = boxRightX - boxLeftX;
    const boxMidX = boxLeftX + boxWidth / 2;
    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    const titleWidths = doc.getTextWidth("Issued By,Signature");
    const titleText = String(data?.salefrom?.title || "");
    doc.text("Issued By,Signature", rightXs, boxTopY, { align: "right" });
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text(titleText, rightXs, boxTopY + 4, { align: "right" });
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        // Convert image URL to base64
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(signimg);
        const imgX = rightXs - imgWidth;
        doc.addImage(base64, format, imgX, boxTopY + 6, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }
    setDownload(false);
    // setPrint(false);
    return doc;
  };

  const generateinvoiceA5PDF = async () => {
    const doc = new jsPDF({ format: "a5" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    if (data?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 30;
        const maxHeight = 8;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 14;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = data.salemode && formatTrackMode(data.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (data.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(8);
    const invoiceNoLabel = "Invoice No:";
    const invoiceNoValue = data.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      data.saledate,
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 5;
    const innerGap = 2;
    const invoiceRowY = 18;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor("#e2e4e6");
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 25;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);

    // --- Invoice From ---
    doc.text("Invoice From:", padding, sectionTop);
    let fromY = sectionTop + 5;

    // Build one single line
    const fromDetailsLine = [
      data.salefrom?.title || "-",
      [
        data.salefrom?.addressline1,
        data.salefrom?.addressline2,
        data.salefrom?.district,
        data.salefrom?.country,
        data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
      ]
        .filter(Boolean)
        .join(", "),
      data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
      data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
      data.salefrom?.gstnumber ? `GST: ${data.salefrom.gstnumber}` : "",
      data.salefrom?.pannumber ? `PAN: ${data.salefrom.pannumber}` : "",
      data.salefrom?.state
        ? `State: ${data.salefrom.state} [State Code: ${
            data.salefrom?.statecode || ""
          }]`
        : "",
    ]
      .filter(Boolean)
      .join(", ");

    // Render in one line (will wrap automatically if too long)
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text(
      doc.splitTextToSize(fromDetailsLine, pageWidth - padding * 2),
      padding,
      fromY,
    );

    let toY = fromY + 12; // spacing

    // --- Invoice To ---
    const hasSaleToData =
      data.saleto &&
      (data.saleto.name ||
        data.saleto.addressline1 ||
        data.saleto.addressline2 ||
        data.saleto.district ||
        data.saleto.country ||
        data.saleto.pincode ||
        data.saleto.phone ||
        data.saleto.email ||
        data.saleto.gstnumber ||
        data.saleto.state ||
        data.saleto.statecode ||
        data.saleto.referid);

    if (hasSaleToData) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Invoice To:", padding, toY);

      toY += 5;

      const toDetailsLine = [
        data.saleto?.name || "-",
        [
          data.saleto?.addressline1,
          data.saleto?.addressline2,
          data.saleto?.district,
          data.saleto?.country,
          data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
        ]
          .filter(Boolean)
          .join(", "),
        data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
        data.saleto?.email ? `Email: ${data.saleto.email}` : "",
        data.saleto?.gstnumber ? `GST: ${data.saleto.gstnumber}` : "",
        data.saleto?.state
          ? `State: ${data.saleto.state} [State Code: ${
              data.saleto?.statecode || ""
            }]`
          : "",
        data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(9);
      doc.text(
        doc.splitTextToSize(toDetailsLine, pageWidth - padding * 2),
        padding,
        toY,
      );
    }

    // 3. Product Table
    const productBody = data.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = CurrencyConverter.toCurrency(item.soldprice || 0, "INR");
      const total = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR",
      );
      const gross = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR",
      );
      const taxable = CurrencyConverter.toCurrency(
        item.lineTotalBasePrice || 0,
        "INR",
      );
      const gstAmt = CurrencyConverter.toCurrency(
        item.lineTotalTaxAmount || 0,
        "INR",
      );

      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
        ...(item.discount > 0
          ? [`MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`]
          : []),
        ...(item.discount > 0
          ? [
              `Discount: - ₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR",
              )}`,
            ]
          : []),
        `GST     : ${item.taxpercentage}%`,
      ].join("\n");

      return [
        i + 1,
        desc,
        `₹${rate}`,
        qty,
        `₹${gross}`,
        `₹${taxable}`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: data.totalqty,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalsoldprice || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalbaseprice || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totaltaxamount || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.grandtotal || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);

    autoTable(doc, {
      startY: Math.max(fromY, toY) + 10,
      head: [
        [
          "S.No",
          "Description",
          "Rate",
          "Qty",
          "Gross Amount",
          "Taxable Value",
          "GST Amount",
          "Total",
        ],
      ],
      body: productBody,
      margin: { left: padding, right: padding },
      tableWidth: "auto",
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        lineColor: [200, 200, 200],
        lineWidth: 0.2,
        valign: "middle",
      },
      headStyles: {
        fillColor: "#f4f4f6",
        textColor: "#292d51",
        font: "Inter-Bold",
        fontStyle: "bold",
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        1: { cellWidth: 40, halign: "left" },
      },
      theme: "grid",
    });

    // const isInterState =
    //   data.salefrom?.statecode &&
    //   data.saleto?.statecode &&
    //   data.salefrom.statecode !== data.saleto.statecode;
    // const body = [
    //   [
    //     {
    //       content: "Total Amount In Words",
    //       styles: {
    //         fontStyle: "bold",
    //         font: "Inter-Bold",
    //         fontSize: 9,
    //         valign: "top",
    //       },
    //     },
    //     {
    //       content: "Total Amount Before Tax",
    //       styles: { halign: "right", fontSize: 9 },
    //     },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         data.totalbaseprice || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ],
    //   [
    //     {
    //       content: data.amountinwords,
    //       rowSpan: isInterState ? 3 : 4,
    //       styles: {
    //         halign: "center",
    //         valign: "middle",
    //         fontSize: 9,
    //       },
    //     },
    //     {
    //       content: isInterState ? "IGST" : "SGST",
    //       styles: { halign: "right", fontSize: 9 },
    //     },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         isInterState ? data.igstamount || 0 : data.sgstamount || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ],
    // ];
    // if (!isInterState) {
    //   body.push([
    //     { content: "CGST", styles: { halign: "right", fontSize: 9 } },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         data.cgstamount || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ]);
    // }
    // // Add Total row
    // body.push([
    //   { content: "Total", styles: { halign: "right", fontSize: 9 } },
    //   {
    //     content: `₹${CurrencyConverter.toCurrency(
    //       data.totalsoldprice || 0,
    //       "INR"
    //     )}`,
    //     styles: { halign: "center", valign: "middle", fontSize: 9 },
    //   },
    // ]);
    // // Add Grand Total row
    // body.push([
    //   {
    //     content: "Grand Total (Rounded)",
    //     styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
    //   },
    //   {
    //     content: `₹ ${CurrencyConverter.toCurrency(
    //       data.grandtotal || 0,
    //       "INR"
    //     )}`,
    //     styles: {
    //       halign: "center",
    //       valign: "middle",
    //       fontStyle: "bold",
    //       fontSize: 10,
    //     },
    //   },
    // ]);
    // const afterProductsY = doc.lastAutoTable?.finalY + 0.3;
    // const pageHeight = doc.internal.pageSize.getHeight();
    // const marginBottom = 20;
    // const estimatedSummaryHeight = 50;
    // let summaryStartY;
    // let isSamePage = true;
    // if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
    //   summaryStartY = afterProductsY;
    // } else {
    //   doc.addPage();
    //   summaryStartY = 20;
    //   isSamePage = false;
    // }
    // autoTable(doc, {
    //   startY: summaryStartY,
    //   body: body,
    //   pageBreak: "avoid",
    //   margin: { left: 6, right: 5 },
    //   tableWidth: doc.internal.pageSize.getWidth() - 10,
    //   styles: {
    //     font: "Inter-Regular",
    //     fontStyle: "normal",
    //     halign: "middle",
    //     cellPadding: 2,
    //     fontSize: 8,
    //     lineColor: [200, 200, 200],
    //     lineWidth: 0.2,
    //     textColor: "#041121",
    //   },
    //   columnStyles: {
    //     0: { cellWidth: 103 },
    //     1: { cellWidth: 73, halign: "right" },
    //     2: { cellWidth: 20, halign: "center", valign: "middle" },
    //   },
    //   didParseCell: function (data) {
    //     if (data.row.index === 0 && isSamePage) {
    //       data.cell.styles.lineWidth = {
    //         top: 0,
    //         right: 0.2,
    //         bottom: 0.2,
    //         left: 0.2,
    //       };
    //     }
    //     const lastRowIndex = body.length - 1;
    //     if (data.section === "body") {
    //       if (data.row.index === lastRowIndex) {
    //         data.cell.styles.fillColor = "#f4f4f6";
    //         data.cell.styles.textColor = [0, 0, 0];
    //         data.cell.styles.font = "Inter-Bold";
    //         data.cell.styles.fontStyle = "bold";
    //       } else {
    //         data.cell.styles.font = "Inter-Regular";
    //         data.cell.styles.fontStyle = "normal";
    //       }
    //     }
    //   },
    //   theme: "grid",
    // });
    // const afterSummaryY = doc.lastAutoTable.finalY;
    // const pageHeight2 = doc.internal.pageSize.getHeight();
    // const marginBottom2 = 20;
    // const declarationHeight = 45;
    // let finalY;
    // if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
    //   doc.addPage();
    //   finalY = 10;
    // } else {
    //   finalY = afterSummaryY;
    // }
    let finalY;
    finalY = doc.lastAutoTable?.finalY + 0.3;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text(
        `Your Total Discount : ₹${CurrencyConverter.toCurrency(
          data.totaldiscount || 0,
          "INR",
        )}`,
        pageWidth / 2,
        finalY + 10,
        { align: "center" },
      );
    }
    const footerY = finalY + 15;
    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, footerY, {
      align: "center",
    });
    const footerTextY = footerY + 5;
    const midX = pageWidth / 2;

    // Line 1: Powered By (normal)
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);
    if (storeSettings?.negobillBranding) {
      doc.text("Powered By", midX, footerTextY, { align: "center" });

      // Line 2: www.NegoBill.com (bold)
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("www.NegoBill.com", midX, footerTextY + 6, { align: "center" });
    }
    setDownload(false);
    // setPrint(false);
    return doc;
  };

  const generateBillA5PDF = async () => {
    const doc = new jsPDF({ format: "a5" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    if (data?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 30;
        const maxHeight = 8;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 14;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = data.salemode && formatTrackMode(data.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (data.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(8);
    const invoiceNoLabel = "Bill No:";
    const invoiceNoValue = data.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      data.saledate,
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 5;
    const innerGap = 2;
    const invoiceRowY = 18;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor("#e2e4e6");
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 25;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);

    // --- Invoice From ---
    doc.text("Bill From:", padding, sectionTop);
    let fromY = sectionTop + 5;

    // Build one single line
    const fromDetailsLine = [
      data.salefrom?.title || "-",
      [
        data.salefrom?.addressline1,
        data.salefrom?.addressline2,
        data.salefrom?.district,
        data.salefrom?.country,
        data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
      ]
        .filter(Boolean)
        .join(", "),
      data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
      data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
      data.salefrom?.state
        ? `State: ${data.salefrom.state} [State Code: ${
            data.salefrom?.statecode || ""
          }]`
        : "",
    ]
      .filter(Boolean)
      .join(", ");

    // Render in one line (will wrap automatically if too long)
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text(
      doc.splitTextToSize(fromDetailsLine, pageWidth - padding * 2),
      padding,
      fromY,
    );

    let toY = fromY + 12; // spacing

    // --- Invoice To ---
    const hasSaleToData =
      data.saleto &&
      (data.saleto.name ||
        data.saleto.addressline1 ||
        data.saleto.addressline2 ||
        data.saleto.district ||
        data.saleto.country ||
        data.saleto.pincode ||
        data.saleto.phone ||
        data.saleto.email ||
        data.saleto.gstnumber ||
        data.saleto.state ||
        data.saleto.statecode ||
        data.saleto.referid);

    if (hasSaleToData) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Bill To:", padding, toY);

      toY += 5;

      const toDetailsLine = [
        data.saleto?.name || "-",
        [
          data.saleto?.addressline1,
          data.saleto?.addressline2,
          data.saleto?.district,
          data.saleto?.country,
          data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
        ]
          .filter(Boolean)
          .join(", "),
        data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
        data.saleto?.email ? `Email: ${data.saleto.email}` : "",
        data.saleto?.state
          ? `State: ${data.saleto.state} [State Code: ${
              data.saleto?.statecode || ""
            }]`
          : "",
        data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(9);
      doc.text(
        doc.splitTextToSize(toDetailsLine, pageWidth - padding * 2),
        padding,
        toY,
      );
    }

    // 3. Product Table
    const productBody = data.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = CurrencyConverter.toCurrency(item.soldprice || 0, "INR");
      const total = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR",
      );

      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
        ...(item.discount > 0
          ? [`MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`]
          : []),
        ...(item.discount > 0
          ? [
              `Discount: - ₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR",
              )}`,
            ]
          : []),
      ].join("\n");

      return [i + 1, desc, `₹${rate}`, qty, `₹${total}`];
    });

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: data.totalqty,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.grandtotal || 0,
          "INR",
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);

    autoTable(doc, {
      startY: Math.max(fromY, toY) + 10,
      head: [["S.No", "Description", "Rate", "Qty", "Total"]],
      body: productBody,
      margin: { left: padding, right: padding },
      tableWidth: "auto",
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        lineColor: [200, 200, 200],
        lineWidth: 0.2,
        valign: "middle",
      },
      headStyles: {
        fillColor: "#f4f4f6",
        textColor: "#292d51",
        font: "Inter-Bold",
        fontStyle: "bold",
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        1: { cellWidth: 40, halign: "left" },
      },
      theme: "grid",
    });

    // const isInterState =
    //   data.salefrom?.statecode &&
    //   data.saleto?.statecode &&
    //   data.salefrom.statecode !== data.saleto.statecode;
    // const body = [
    //   [
    //     {
    //       content: "Total Amount In Words",
    //       styles: {
    //         fontStyle: "bold",
    //         font: "Inter-Bold",
    //         fontSize: 9,
    //         valign: "top",
    //       },
    //     },
    //     {
    //       content: "Total Amount Before Tax",
    //       styles: { halign: "right", fontSize: 9 },
    //     },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         data.totalbaseprice || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ],
    //   [
    //     {
    //       content: data.amountinwords,
    //       rowSpan: isInterState ? 3 : 4,
    //       styles: {
    //         halign: "center",
    //         valign: "middle",
    //         fontSize: 9,
    //       },
    //     },
    //     {
    //       content: isInterState ? "IGST" : "SGST",
    //       styles: { halign: "right", fontSize: 9 },
    //     },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         isInterState ? data.igstamount || 0 : data.sgstamount || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ],
    // ];
    // if (!isInterState) {
    //   body.push([
    //     { content: "CGST", styles: { halign: "right", fontSize: 9 } },
    //     {
    //       content: `₹${CurrencyConverter.toCurrency(
    //         data.cgstamount || 0,
    //         "INR"
    //       )}`,
    //       styles: { halign: "center", valign: "middle", fontSize: 9 },
    //     },
    //   ]);
    // }
    // // Add Total row
    // body.push([
    //   { content: "Total", styles: { halign: "right", fontSize: 9 } },
    //   {
    //     content: `₹${CurrencyConverter.toCurrency(
    //       data.totalsoldprice || 0,
    //       "INR"
    //     )}`,
    //     styles: { halign: "center", valign: "middle", fontSize: 9 },
    //   },
    // ]);
    // // Add Grand Total row
    // body.push([
    //   {
    //     content: "Grand Total (Rounded)",
    //     styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
    //   },
    //   {
    //     content: `₹ ${CurrencyConverter.toCurrency(
    //       data.grandtotal || 0,
    //       "INR"
    //     )}`,
    //     styles: {
    //       halign: "center",
    //       valign: "middle",
    //       fontStyle: "bold",
    //       fontSize: 10,
    //     },
    //   },
    // ]);
    // const afterProductsY = doc.lastAutoTable?.finalY + 0.3;
    // const pageHeight = doc.internal.pageSize.getHeight();
    // const marginBottom = 20;
    // const estimatedSummaryHeight = 50;
    // let summaryStartY;
    // let isSamePage = true;
    // if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
    //   summaryStartY = afterProductsY;
    // } else {
    //   doc.addPage();
    //   summaryStartY = 20;
    //   isSamePage = false;
    // }
    // autoTable(doc, {
    //   startY: summaryStartY,
    //   body: body,
    //   pageBreak: "avoid",
    //   margin: { left: 6, right: 5 },
    //   tableWidth: doc.internal.pageSize.getWidth() - 10,
    //   styles: {
    //     font: "Inter-Regular",
    //     fontStyle: "normal",
    //     halign: "middle",
    //     cellPadding: 2,
    //     fontSize: 8,
    //     lineColor: [200, 200, 200],
    //     lineWidth: 0.2,
    //     textColor: "#041121",
    //   },
    //   columnStyles: {
    //     0: { cellWidth: 103 },
    //     1: { cellWidth: 73, halign: "right" },
    //     2: { cellWidth: 20, halign: "center", valign: "middle" },
    //   },
    //   didParseCell: function (data) {
    //     if (data.row.index === 0 && isSamePage) {
    //       data.cell.styles.lineWidth = {
    //         top: 0,
    //         right: 0.2,
    //         bottom: 0.2,
    //         left: 0.2,
    //       };
    //     }
    //     const lastRowIndex = body.length - 1;
    //     if (data.section === "body") {
    //       if (data.row.index === lastRowIndex) {
    //         data.cell.styles.fillColor = "#f4f4f6";
    //         data.cell.styles.textColor = [0, 0, 0];
    //         data.cell.styles.font = "Inter-Bold";
    //         data.cell.styles.fontStyle = "bold";
    //       } else {
    //         data.cell.styles.font = "Inter-Regular";
    //         data.cell.styles.fontStyle = "normal";
    //       }
    //     }
    //   },
    //   theme: "grid",
    // });
    // const afterSummaryY = doc.lastAutoTable.finalY;
    // const pageHeight2 = doc.internal.pageSize.getHeight();
    // const marginBottom2 = 20;
    // const declarationHeight = 45;
    // let finalY;
    // if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
    //   doc.addPage();
    //   finalY = 10;
    // } else {
    //   finalY = afterSummaryY;
    // }
    let finalY;
    finalY = doc.lastAutoTable?.finalY + 0.3;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text(
        `Your Total Discount : ₹${CurrencyConverter.toCurrency(
          data.totaldiscount || 0,
          "INR",
        )}`,
        pageWidth / 2,
        finalY + 10,
        { align: "center" },
      );
    }
    const footerY = finalY + 15;
    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, footerY, {
      align: "center",
    });
    const footerTextY = footerY + 5;
    const midX = pageWidth / 2;

    // Line 1: Powered By (normal)
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);
    if (storeSettings?.negobillBranding) {
      doc.text("Powered By", midX, footerTextY, { align: "center" });

      // Line 2: www.NegoBill.com (bold)
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("www.NegoBill.com", midX, footerTextY + 6, { align: "center" });
    }
    setDownload(false);
    // setPrint(false);
    return doc;
  };
  if (isReturnView) {
    return (
      <ReturnSaleInvoice
        isData={returnData} // This is the updated return sale data loaded by your hook
        selectedOption={selectedOption}
        saleId={isData?._id}
        onClose={handleClose}
        onDataUpdate={onDataUpdate}
        onDataChange={onDataChange}
        isActive={isActive}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={data}
        generateInvoice1={generateInvoice1}
        generateBill1={generateBill1}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        onClose={handleClose}
        {...invoiceData}
      >
        <InvoiceToggleActionCard
          optData={optData}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            {globalData.salemode === "INVOICE" || isBillReceipt ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <div className="row">
                            <div className="col-7 pe-1 ">
                              <div className="border p-2 h-100 d-flex ">
                                <div className="d-flex gap-2 align-items-start">
                                  <div className="tm_logo">
                                    {globalData?.salefrom?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          globalData?.salefrom?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="45"
                                        width="150"
                                        style={{
                                          objectFit: "contain",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData?.salefrom?.title || ""}
                                    </div>
                                    <div>
                                      {globalData?.salefrom?.addressline1 || ""}{" "}
                                      {globalData?.salefrom?.addressline2 ||
                                        ""}{" "}
                                    </div>
                                    <div>
                                      {globalData?.salefrom?.state || ""}{" "}
                                      {globalData?.salefrom?.district || ""}{" "}
                                      {globalData?.salefrom?.country || ""} -{" "}
                                      {globalData?.salefrom?.pincode || ""}
                                    </div>
                                    <div>
                                      CIN :{globalData?.salefrom?.cinnumber}
                                    </div>
                                    {globalData?.salefrom?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.salefrom?.pannumber || ""}
                                      </div>
                                    )}
                                    <div>
                                      {" "}
                                      Phone: +91{" "}
                                      {globalData?.salefrom?.phone || ""}
                                    </div>
                                    {globalData?.salefrom?.gstnumber && (
                                      <div>
                                        <strong>GSTIN:</strong>{" "}
                                        {globalData?.salefrom?.gstnumber || ""}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-5 ps-1 ">
                              <div className="border h-100 p-2">
                                <div className="tm_text_uppercase text-end">
                                  {globalData?.salemode &&
                                    formatTrackMode(globalData?.salemode)}
                                </div>
                                <div>
                                  <b>{invLabel}</b> {globalData?.saleno}
                                </div>
                                <div>
                                  <b>Date</b> : {saleTime?.date}
                                </div>
                                <div>
                                  <b>Place Of Supply</b> :{" "}
                                  {globalData?.salefrom?.state || ""}
                                </div>
                                <div>
                                  <b>Due Date</b> : {saleTime?.date}
                                </div>
                                <div>
                                  <b>Sales Person</b> : -
                                </div>
                              </div>
                            </div>
                          </div>
                          {globalData?.saleto && optData.isCustomerDisplay && (
                            <div className="row mt-2">
                              <div className="col-6 pe-1">
                                <div className="border p-2 h-100 ">
                                  <div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      Customer Details
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData?.saleto?.name || ""}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.addressline1 || ""}{" "}
                                      {globalData?.saleto?.addressline2 ||
                                        ""}{" "}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.state || ""}{" "}
                                      {globalData?.saleto?.district || ""}{" "}
                                      {/* {globalData?.saleto?.country || ""} -{" "} */}
                                      {globalData?.saleto?.pincode || ""}
                                    </div>
                                    <div>
                                      {" "}
                                      Phone: +91{" "}
                                      {globalData?.saleto?.phone || ""}
                                    </div>
                                    {globalData?.saleto?.email && (
                                      <div>
                                        {" "}
                                        Email {globalData?.saleto?.email || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.referenceid && (
                                      <div>
                                        <span>Reference No:</span>{" "}
                                        {globalData?.saleto?.referenceid || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.gstnumber && (
                                      <div>
                                        <span>GSTIN:</span>{" "}
                                        {globalData?.saleto?.gstnumber || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.fssai && (
                                      <div>
                                        <span>FASSI:</span>{" "}
                                        {globalData?.saleto?.fssai || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.pannumber && (
                                      <div>
                                        <span>PAN:</span>{" "}
                                        {globalData?.saleto?.pannumber || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.cinnumber && (
                                      <div>
                                        CIN :
                                        {globalData?.saleto?.cinnumber || ""}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {globalData?.saleto?.shippingAddress
                                ?.addressline1 &&
                                globalData?.saleto?.shippingAddress
                                  ?.addressline2 && (
                                  <div className="col-6 ps-1">
                                    <div className="border p-2 h-100 ">
                                      <div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          Shipping Address
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          {globalData?.saleto?.shippingAddress
                                            ?.name || ""}
                                        </div>
                                        <div>
                                          {globalData?.saleto?.shippingAddress
                                            ?.addressline1 || ""}{" "}
                                          {globalData?.saleto?.shippingAddress
                                            ?.addressline2 || ""}{" "}
                                        </div>
                                        <div>
                                          {globalData?.saleto?.shippingAddress
                                            ?.state || ""}{" "}
                                          {globalData?.saleto?.shippingAddress
                                            ?.district || ""}{" "}
                                          {
                                            globalData?.saleto?.shippingAddress
                                              ?.city
                                          }{" "}
                                          {globalData?.saleto?.shippingAddress
                                            ?.country || ""}{" "}
                                          -{" "}
                                          {globalData?.saleto?.shippingAddress
                                            ?.pincode || ""}
                                        </div>
                                        {/* <div>
                                    {" "}
                                    Phone: +91 {data.saleto?.phone || ""}
                                  </div>
                                  <div>
                                    {" "}
                                    Email {data.saleto?.email || ""}
                                  </div>
                                  {data.saleto?.gstnumber && (
                                    <div>
                                      <span>GSTIN:</span>{" "}
                                      {data.saleto?.gstnumber || ""}
                                    </div>
                                  )}
                                   {data.saleto?.pannumber && (
                                    <div>
                                      <span>PAN:</span>{" "}
                                      {data.saleto?.pannumber || ""}
                                    </div>
                                  )}
                                  <div>CIN :</div> */}
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )}

                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "20px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "240px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Description
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "120px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  HSN/SAC
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "50px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  MRP
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Base Price
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="force-style"
                                  style={{
                                    width: "30px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Taxable Value
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Tax
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Tax Amount
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {globalData?.saleitems?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "30%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    <div>{product?.title}</div>
                                    {/* {product?.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product?.description}
                                      </div>
                                    )} */}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fsz-10 mb-1">
                                          {product?.note}
                                        </div>
                                      )}
                                    {/* {product.hsnsac && (
                                      <div>
                                        <span className="fw-medium">
                                          {" "}
                                          {product.imode === "SERVICE" ? "SAC:" : "HSN:"}
                                        </span>{" "}
                                        {product.hsnsac}
                                      </div>
                                    )}
                                    {product.discount > 0 && (
                                      <>
                                        <div>
                                          <span className="fw-medium">MRP : </span> ₹
                                          {CurrencyConverter.toCurrency(
                                            product.mrp || 0,
                                            "INR"
                                          )}
                                        </div>
                                        <div>
                                          <span className="fw-medium">Discount : </span> -
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.discount || 0,
                                            "INR"
                                          )}
                                        </div>
                                      </>
                                    )} */}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product?.hsnsac}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product?.mrp}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product?.baseprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product?.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>

                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product?.lineTotalBasePrice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {`${product?.taxpercentage}%`}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product?.lineTotalTaxAmount}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product?.lineGrandTotal}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan="6">
                                  Total Items : {globalData?.saleitems?.length}
                                </td>
                                <td colSpan="3">Total Amount Before Tax :</td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  ₹{globalData?.totalbaseprice}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colSpan="6"
                                  style={{ verticalAlign: "top" }}
                                >
                                  {globalData?.grandtotal > 0 &&
                                    optData?.isPayment && (
                                      <table
                                        className="items"
                                        width="50%"
                                        cellPadding="4"
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              colSpan={2}
                                              className="force-style"
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                "--th-bg":
                                                  selectedTheme?.templateTheme
                                                    ?.primaryColor,
                                                "--th-color":
                                                  selectedTheme?.templateTheme
                                                    ?.foregroundColor,
                                              }}
                                            >
                                              Payment Mode
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {(globalData?.cashamount || 0) -
                                            (globalData?.cashchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                Cash
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.cashPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.cardamount || 0) -
                                            (globalData?.cardchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                Card
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.cardPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.onlineamount || 0) -
                                            (globalData?.onlinechange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                OnlineAmount
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.onlinePaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.upiamount || 0) -
                                            (globalData?.upichange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                UPI
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.upiPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.paylateramount || 0) -
                                            (globalData?.paylaterchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                BalanceDue
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.balanceDue}
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                </td>
                                <td
                                  colSpan="3"
                                  style={{ verticalAlign: "top" }}
                                >
                                  {globalData?.salefrom?.statecode &&
                                  globalData?.saleto?.statecode &&
                                  globalData?.salefrom?.statecode !==
                                    globalData?.saleto?.statecode ? (
                                    <div>IGST</div>
                                  ) : (
                                    <>
                                      <div>SGST :</div>
                                      <div>CGST :</div>
                                    </>
                                  )}
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Total Amount :
                                  </div>
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    fontSize: "12px",
                                    verticalAlign: "top",
                                  }}
                                >
                                  {globalData?.salefrom?.statecode &&
                                  globalData?.saleto?.statecode &&
                                  globalData?.salefrom?.statecode !==
                                    globalData?.saleto?.statecode ? (
                                    <div>₹{globalData?.igstamount}</div>
                                  ) : (
                                    <>
                                      <div> {globalData?.sgstamount}</div>
                                      <div>₹{globalData?.cgstamount}</div>
                                    </>
                                  )}
                                  <div
                                    style={{
                                      textAlign: "end",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    ₹{globalData?.grandtotal}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="row mt-2">
                            <div className="col-4 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && globalData?.remark ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1 mt-2">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          globalData?.remark,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && (
                                    <>
                                      <div
                                        className="fs-13 fw-600 mt-2"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {globalData?.salefrom?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : globalData.salemode === "BILL" ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <div className="row">
                            <div className="col-7 pe-1 ">
                              <div className="border p-2 h-100 d-flex ">
                                <div className="d-flex gap-2 align-items-start">
                                  <div className="tm_logo">
                                    {globalData?.salefrom?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          globalData?.salefrom?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="45"
                                        width="150"
                                        style={{
                                          objectFit: "contain",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData.salefrom?.title || ""}
                                    </div>
                                    <div>
                                      {globalData?.salefrom?.addressline1 || ""}{" "}
                                      {globalData?.salefrom?.addressline2 ||
                                        ""}{" "}
                                    </div>
                                    <div>
                                      {globalData?.salefrom?.state || ""}{" "}
                                      {globalData?.salefrom?.district || ""}{" "}
                                      {globalData?.salefrom?.country || ""} -{" "}
                                      {globalData?.salefrom?.pincode || ""}
                                    </div>
                                    {globalData?.salefrom?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.salefrom?.pannumber || ""}
                                      </div>
                                    )}
                                    <div>
                                      {" "}
                                      Phone: {globalData?.salefrom?.phone || ""}
                                    </div>
                                    <div>
                                      {" "}
                                      Email: {globalData?.salefrom?.email || ""}
                                    </div>
                                    {globalData?.salefrom?.gstnumber && (
                                      <div>
                                        <strong>GSTIN:</strong>{" "}
                                        {globalData?.salefrom?.gstnumber || ""}
                                      </div>
                                    )}
                                    {globalData?.salefrom?.fssai && (
                                      <div>
                                        <strong>FSSAI:</strong>{" "}
                                        {globalData?.salefrom?.fssai || ""}
                                      </div>
                                    )}
                                    {globalData?.salefrom?.cin && (
                                      <div>
                                        <strong>CIN:</strong>{" "}
                                        {globalData?.salefrom?.cin || ""}
                                      </div>
                                    )}
                                    {globalData?.salefrom?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.salefrom?.pannumber || ""}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-5 ps-1 ">
                              <div className="border h-100 p-2">
                                <div className="tm_text_uppercase text-end">
                                  {globalData.salemode &&
                                    formatTrackMode(globalData.salemode)}
                                </div>
                                <div>
                                  <b>Bill #</b> : {globalData.saleno}
                                </div>
                                <div>
                                  <b>Date</b> : {saleTime.date}
                                </div>
                                <div>
                                  <b>Place Of Supply</b> :{" "}
                                  {globalData?.salefrom?.state || ""}
                                </div>
                                <div>
                                  <b>Due Date</b> : {saleTime.date}
                                </div>
                                <div>
                                  <b>Sales Person</b> : -
                                </div>
                              </div>
                            </div>
                          </div>
                          {globalData?.saleto && optData?.isCustomerDisplay && (
                            <div className="row mt-2">
                              <div className="col-6 pe-1">
                                <div className="border p-2 h-100 ">
                                  <div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      Customer Details
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {globalData?.saleto?.name || ""}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.addressline1 || ""}{" "}
                                      {globalData?.saleto?.addressline2 ||
                                        ""}{" "}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.state || ""}{" "}
                                      {globalData?.saleto?.district || ""}{" "}
                                      {/* {globalData?.saleto?.country || ""} -{" "} */}
                                      {globalData?.saleto?.pincode || ""}
                                    </div>
                                    <div>
                                      {" "}
                                      Phone: +91{" "}
                                      {globalData?.saleto?.phone || ""}
                                    </div>
                                    {globalData?.saleto?.email && (
                                      <div>
                                        {" "}
                                        Email {globalData?.saleto?.email || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.referenceid && (
                                      <div>
                                        <span>Reference No:</span>{" "}
                                        {globalData?.saleto?.referenceid || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.gstnumber && (
                                      <div>
                                        <strong>GSTIN:</strong>{" "}
                                        {globalData?.saleto?.gstnumber || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.fssai && (
                                      <div>
                                        <strong>FASSI:</strong>{" "}
                                        {globalData?.saleto?.fssai || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.saleto?.pannumber || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.cin && (
                                      <div>
                                        <strong>CIN:</strong>{" "}
                                        {globalData?.saleto?.cin || ""}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {(globalData?.saleto?.shippingAddress
                                ?.addressline1 ||
                                globalData?.saleto?.shippingAddress
                                  ?.addressline2) && (
                                <div className="col-6 ps-1">
                                  <div className="border p-2 h-100 ">
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        Shipping Address
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {
                                          globalData?.saleto?.shippingAddress
                                            ?.name
                                        }
                                      </div>
                                      <div>
                                        {globalData?.saleto?.shippingAddress
                                          ?.addressline1 || ""}{" "}
                                        {globalData?.saleto?.shippingAddress
                                          ?.addressline2 || ""}{" "}
                                      </div>
                                      <div>
                                        {globalData?.saleto?.shippingAddress
                                          ?.state || ""}{" "}
                                        {globalData?.saleto?.shippingAddress
                                          ?.district || ""}{" "}
                                        {
                                          globalData?.saleto?.shippingAddress
                                            ?.city
                                        }{" "}
                                        {globalData?.saleto?.shippingAddress
                                          ?.country || ""}{" "}
                                        -{" "}
                                        {globalData?.saleto?.shippingAddress
                                          ?.pincode || ""}
                                      </div>
                                      {/* <div>
                                    {" "}
                                    Phone: {data.saleto?.phone || ""}
                                  </div>
                                  {data.saleto?.gstnumber && (
                                    <div>
                                      <span>GSTIN:</span>{" "}
                                      {data.saleto?.gstnumber || ""}
                                    </div>
                                  )} */}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Description
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  HSN/SAC
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  MRP
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Discount
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="force-style"
                                  style={{
                                    // width: "10px",
                                    textAlign: "center",
                                    //   background: "#f3f3f3",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {globalData?.saleitems?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "5%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "65%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )} */}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fs-12 text-truncate-description text-muted">
                                          {product?.note}
                                        </div>
                                      )}

                                    {/* <div>
                                      {product.hsnsac && (
                                        <span>
                                          <span className="fw-medium">
                                            HSN/SAC :{" "}
                                          </span>{" "}
                                          {product.hsnsac}
                                        </span>
                                      )}
                                      {product.discount > 0 && (
                                        <>
                                          <>
                                            {" "}
                                            <span className="fw-medium">
                                              MRP :{" "}
                                            </span>{" "}
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              product.mrp || 0,
                                              "INR"
                                            )}
                                          </>{" "}
                                          <>
                                            <span className="fw-medium">
                                              Discount :{" "}
                                            </span>{" "}
                                             ₹
                                            {CurrencyConverter.toCurrency(
                                              product.discount || 0,
                                              "INR"
                                            )}
                                          </>
                                        </>
                                      )}{" "}
                                      {product.taxpercentage > 0 && (
                                        <>
                                          <span className="fw-medium">
                                            Tax :{" "}
                                          </span>{" "}
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.baseprice || 0,
                                            "INR"
                                          )}
                                          @{product.taxpercentage}% = ₹
                                          {CurrencyConverter.toCurrency(
                                            product.taxamount || 0,
                                            "INR"
                                          )}
                                        </>
                                      )}
                                    </div> */}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.hsnsac}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.mrp}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.discount}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.soldprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    {product.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>

                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹{product.lineGrandTotal}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan="4">
                                  Total Items : {globalData?.saleitems?.length}
                                </td>
                                <td
                                  colSpan="3"
                                  style={{
                                    textAlign: "end",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                  }}
                                >
                                  Total Amount :
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                  }}
                                >
                                  ₹{globalData?.grandtotal}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colSpan="7"
                                  style={{ verticalAlign: "top" }}
                                >
                                  {globalData?.grandtotal > 0 &&
                                    optData?.isPayment && (
                                      <table
                                        className="items"
                                        width="50%"
                                        cellPadding="4"
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              colSpan={2}
                                              className="force-style"
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                "--th-bg":
                                                  selectedTheme?.templateTheme
                                                    ?.primaryColor,
                                                "--th-color":
                                                  selectedTheme?.templateTheme
                                                    ?.foregroundColor,
                                              }}
                                            >
                                              Payment Mode
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {(globalData?.cashamount || 0) -
                                            (globalData?.cashchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                Cash
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.cashPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.cardamount || 0) -
                                            (globalData?.cardchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                Card
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.cardPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.onlineamount || 0) -
                                            (globalData?.onlinechange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                OnlineAmount
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.onlinePaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.upiamount || 0) -
                                            (globalData?.upichange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                UPI
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.upiPaid}
                                              </td>
                                            </tr>
                                          )}
                                          {(globalData?.paylateramount || 0) -
                                            (globalData?.paylaterchange || 0) >
                                            0 && (
                                            <tr>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                BalanceDue
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "12px",
                                                  width: "10%",
                                                  fontWeight: "600",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{globalData?.balanceDue}
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="row mt-2">
                            <div className="col-4 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl && optData?.isBankDetails && (
                              <div className="col-3 d-flex align-items-center justify-content-end">
                                <img
                                  src={qrCodeDataUrl}
                                  alt="QR"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && globalData?.remark ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1 mt-2">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          globalData?.remark,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && (
                                    <>
                                      <div
                                        className="fs-13 fw-600 mt-2"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {globalData?.salefrom?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="default-content">
                <p>No content available for this sale mode.</p>
              </div>
            )}           
          </div>
        )}
        <InvoiceInfoSidebar
          {...invoiceData}
          isData={isData}
          handleSelectedReturnSale={handleSelectedReturnSale}
        />
      </InvoiceModalLayout>
      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}

      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default StructuredInvoice;
